webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _storesDiscountConfig = __webpack_require__(254);
	
	var _storesDiscountConfig2 = _interopRequireDefault(_storesDiscountConfig);
	
	var _coreRenderingEngine = __webpack_require__(80);
	
	var _coreRenderingEngine2 = _interopRequireDefault(_coreRenderingEngine);
	
	__webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _coreRenderingEngine2.default)(_storesDiscountConfig2.default).startApplication({
	  tags: [{
	    value: 'olst',
	    type: 'olst'
	  }, {
	    value: 'olst-gallery',
	    type: 'olst-gallery'
	  }]
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(212)
	
	/* script */
	__vue_exports__ = __webpack_require__(116)
	
	/* template */
	var __vue_template__ = __webpack_require__(333)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(219)
	
	/* script */
	__vue_exports__ = __webpack_require__(125)
	
	/* template */
	var __vue_template__ = __webpack_require__(340)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-297fbefd"
	
	module.exports = __vue_exports__


/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(21);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _mobile = __webpack_require__(50);
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'olst',
	
	  props: {
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    debug: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {
	    this.isMobile = _mobile2.default.deviceIsMobile();
	  },
	  data: function data() {
	    return {
	      isMobile: false,
	      mint: 0,
	      recipe: {},
	      bundle: {},
	      event: {
	        mounted: null,
	
	        changed: null,
	
	        updated: null
	      }
	    };
	  },
	
	  components: _global2.default.rendering_blocks,
	
	  mounted: function mounted() {
	    var initEvent = function initEvent(eventName) {
	      var event = document.createEvent('Event');
	      event.initEvent(eventName, true, true);
	      return event;
	    };
	
	    this.event.mounted = initEvent('olst-rendering-mounted');
	    this.event.changed = initEvent('olst-rendering-changed');
	    this.event.updated = initEvent('olst-rendering-updated');
	
	    this.registerEventUpdate();
	
	    this.dispatchEventMounted();
	
	    this.dispatchEventUpdated();
	  },
	
	  computed: {},
	
	  watch: {
	    recipe: function recipe() {},
	
	    bundle: function bundle() {
	      if (this.mint < 2) {
	        this.mint++;
	      }
	    }
	  },
	
	  methods: {
	    dispatchEventMounted: function dispatchEventMounted() {
	      this.event.mounted.data = {};
	      this.event.mounted.data.event = 'olst-rendering-mounted';
	      document.dispatchEvent(this.event.mounted);
	    },
	
	    ccDispatchChanged: function ccDispatchChanged(cc) {
	      this.event.changed.data = {};
	      this.event.changed.data.event = 'olst-rendering-changed';
	      this.event.changed.data.cc = (0, _stringify2.default)(cc);
	      document.dispatchEvent(this.event.changed);
	    },
	
	    dispatchEventUpdated: function dispatchEventUpdated() {
	      this.event.updated.data = {};
	      this.event.updated.data.event = 'olst-rendering-updated';
	      document.dispatchEvent(this.event.updated);
	    },
	
	    registerEventUpdate: function registerEventUpdate() {
	      var vue = this;
	
	      var onOlstUpdate = function onOlstUpdate(eventUpdate) {
	        var parsedJson = JSON.parse(eventUpdate.data);
	
	        if (typeof parsedJson.fields !== 'undefined') {
	          vue.recipe = parsedJson;
	          vue.mint = 0;
	        } else if (typeof parsedJson.config_1 !== 'undefined') {
	          vue.bundle = parsedJson;
	        }
	
	        vue.dispatchEventUpdated();
	      };
	      document.addEventListener('olst-rendering-update', onOlstUpdate, false);
	    }
	  }
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(21);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _mobile = __webpack_require__(50);
	
	var _mobile2 = _interopRequireDefault(_mobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'olst-gallery',
	
	  props: {
	    debug: {
	      type: Boolean,
	      default: false
	    }
	  },
	  created: function created() {
	    this.isMobile = _mobile2.default.deviceIsMobile();
	  },
	  data: function data() {
	    return {
	      isMobile: false,
	      recipe: {},
	      bundle: {},
	      event: {
	        mounted: null,
	
	        changed: null,
	
	        updated: null
	      },
	      imageList: []
	    };
	  },
	
	  components: _global2.default.rendering_blocks,
	
	  mounted: function mounted() {
	    var initEvent = function initEvent(eventName) {
	      var event = document.createEvent('Event');
	      event.initEvent(eventName, true, true);
	      return event;
	    };
	
	    this.event.mounted = initEvent('olst-gallery-mounted');
	    this.event.changed = initEvent('olst-gallery-changed');
	    this.event.updated = initEvent('olst-gallery-updated');
	
	    this.registerEventUpdate();
	
	    this.dispatchEventMounted();
	
	    this.dispatchEventUpdated();
	  },
	
	  computed: {},
	
	  watch: {},
	
	  methods: {
	    dispatchEventMounted: function dispatchEventMounted() {
	      this.event.mounted.data = {};
	      this.event.mounted.data.event = 'olst-gallery-mounted';
	      document.dispatchEvent(this.event.mounted);
	    },
	
	    ccDispatchChanged: function ccDispatchChanged(cc) {
	      this.event.changed.data = {};
	      this.event.changed.data.event = 'olst-gallery-changed';
	      this.event.changed.data.cc = (0, _stringify2.default)(cc);
	      document.dispatchEvent(this.event.changed);
	    },
	
	    dispatchEventUpdated: function dispatchEventUpdated() {
	      this.event.updated.data = {};
	      this.event.updated.data.event = 'olst-gallery-updated';
	      document.dispatchEvent(this.event.updated);
	    },
	
	    registerEventUpdate: function registerEventUpdate() {
	      var vue = this;
	
	      var onOlstUpdate = function onOlstUpdate(eventUpdate) {
	        vue.imageList = eventUpdate.data;
	
	        vue.dispatchEventUpdated();
	      };
	      document.addEventListener('olst-gallery-update', onOlstUpdate, false);
	    }
	  }
	};

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'image-component',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    src: {
	      type: String,
	      default: '#'
	    },
	    mouseEnter: {
	      type: Function,
	      default: function _default() {}
	    },
	    mouseOver: {
	      type: Function,
	      default: function _default() {}
	    },
	    mouseMove: {
	      type: Function,
	      default: function _default() {}
	    },
	    mouseLeave: {
	      type: Function,
	      default: function _default() {}
	    },
	    onClick: {
	      type: Function,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'button-component',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    text: {
	      type: [String, Number],
	      default: ''
	    },
	    onClick: {
	      type: Function,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 88 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'checkbox-component',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    change: {
	      type: Function,
	      default: function _default() {}
	    },
	    value: {},
	    isChecked: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.isChecked
	    };
	  },
	
	  watch: {
	    selected: function selected(newValue, oldValue) {
	      this.$emit('value-changed', newValue);
	    },
	    isChecked: function isChecked(newValue, oldValue) {
	      this.selected = newValue;
	    }
	  }
	};

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'input-number-component',
	  props: {
	    'name': {
	      type: String,
	      default: ''
	    },
	    'disabled': {
	      type: Boolean,
	      default: false
	    },
	    'defaultValue': {
	      type: [String, Number],
	      default: 0
	    },
	    'min': {
	      type: [String, Number],
	      default: 0
	    },
	    'max': {
	      type: [String, Number],
	      default: 100
	    }
	  },
	  data: function data() {
	    return {
	      value: null,
	      timeout: null
	    };
	  },
	
	  created: function created() {
	    this.value = this.defaultValue;
	  },
	  computed: {
	    minimum: function minimum() {
	      return this.min === 0 && this.max === 0 ? null : this.min;
	    },
	    maximum: function maximum() {
	      return this.min === 0 && this.max === 0 ? null : this.max;
	    }
	  },
	  watch: {
	    value: function value(newValue, oldValue) {
	      var _this = this;
	
	      if (this.defaultValue !== newValue) {
	        if (this.timeout) {
	          clearTimeout(this.timeout);
	        }
	        this.timeout = setTimeout(function () {
	          _this.$emit('value-changed', newValue);
	        }, 1000);
	      }
	    },
	    defaultValue: function defaultValue(newValue, oldValue) {
	      this.value = newValue;
	    }
	  }
	};

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'input-text-component',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    defaultValue: {
	      type: [String, Number],
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      value: null
	    };
	  },
	
	  created: function created() {
	    this.value = this.defaultValue;
	  },
	  watch: {
	    value: function value(newValue, oldValue) {
	      this.$emit('value-changed', newValue);
	    }
	  }
	};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkbox = __webpack_require__(83);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'multiple-choice',
	  props: {
	    filter: {
	      type: Object,
	      default: { label: '', values: [] }
	    },
	    name: {
	      type: String,
	      default: ''
	    },
	    withAll: {
	      type: Boolean,
	      default: true
	    },
	    bigArea: {
	      type: Boolean,
	      default: false
	    },
	    hideFilters: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      checkboxes: [],
	      checkedCheckboxed: []
	    };
	  },
	  components: {},
	  created: function created() {
	    if (this.withAll) {
	      this.checkboxes.push({
	        label: 'Tout',
	        key: this.name + '-all',
	        onClick: this.toggleAll,
	        isAllCheckbox: true
	      });
	    }
	    for (var index in this.filter.values) {
	      this.checkboxes.push({
	        label: this.filter.values[index].label,
	        key: this.filter.values[index].value,
	        onClick: this.selectOne,
	        isAllCheckbox: false
	      });
	    }
	    for (index in this.checkboxes) {
	      this.checkedCheckboxed.push(this.checkboxes[index].key);
	    }
	  },
	  computed: {
	    getFilterName: function getFilterName() {
	      return 'Filtrer par ' + this.filter.label;
	    }
	  },
	  methods: {
	    labelClicked: function labelClicked() {
	      this.$emit('label-clicked', { name: this.name });
	    },
	
	    toggleAll: function toggleAll() {
	      this.checkedCheckboxed = _checkbox2.default.toggleAll(this.checkboxes, this.checkedCheckboxed, this.checkboxes[0]);
	    },
	
	    selectOne: function selectOne(name) {
	      this.checkedCheckboxed = _checkbox2.default.toggleOneCheckbox(this.checkboxes, this.checkedCheckboxed.slice(0), this.checkboxes[0], name);
	    },
	
	    isCheckboxChecked: function isCheckboxChecked(checkbox) {
	      return this.checkedCheckboxed.indexOf(checkbox.key) !== -1;
	    }
	  },
	  watch: {
	    checkedCheckboxed: function checkedCheckboxed(newValue, oldValue) {
	      var dataEmit = {};
	
	      dataEmit[this.name] = { newValue: newValue };
	      this.$emit('value-changed', dataEmit);
	    }
	  }
	};

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'simple-choice',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    options: {
	      type: [Array, Object],
	      default: { imageUrl: '#', label: '', range: '' }
	    },
	    tooltip_options: {
	      type: [Array, Object],
	      default: function _default() {
	        return {};
	      }
	    },
	    defaultField: {
	      type: [Number, String],
	      default: null
	    },
	    hiddenValues: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    disabledValues: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      selected: null
	    };
	  },
	  created: function created() {
	    if (this.defaultField != null) {
	      this.selected = this.defaultField;
	    }
	  },
	  components: {},
	  computed: {},
	  methods: {
	    setOverElementKey: function setOverElementKey(index) {
	      this.overElementKey = index;
	    },
	
	    showElement: function showElement(elementRef, element) {
	      return this.isHiddenElement(elementRef, element) === false && this.isDisabledElement(elementRef, element) === false;
	    },
	
	    isHiddenElement: function isHiddenElement(elementRef, element) {
	      if (typeof element.range !== 'undefined') {
	        return _common2.default.arrayContain(this.hiddenValues, elementRef) || _common2.default.arrayContain(this.hiddenValues, element.range);
	      } else {
	        return _common2.default.arrayContain(this.hiddenValues, elementRef);
	      }
	    },
	
	    isDisabledElement: function isDisabledElement(elementRef, element) {
	      if (typeof element.range !== 'undefined') {
	        return _common2.default.arrayContain(this.disabledValues, elementRef) || _common2.default.arrayContain(this.disabledValues, element.range);
	      } else {
	        return _common2.default.arrayContain(this.disabledValues, elementRef);
	      }
	    }
	  },
	  watch: {
	    defaultField: function defaultField(newValue, oldValue) {
	      this.selected = newValue;
	    },
	
	    selected: function selected(newValue, oldValue) {
	      var element = null;
	
	      for (var index in this.options) {
	        if (index === newValue) {
	          element = { key: index, value: this.options[index] };
	        }
	      }
	      if (element && (!this.showElement(element.key, element.value) || element.value.outOfStock)) {
	        this.selected = oldValue;
	        return;
	      }
	
	      if ((0, _typeof3.default)(this.options[newValue]) === 'object') {
	        var optionLabel = this.options[newValue].label;
	        var range = this.options[newValue].range;
	        if ((0, _typeof3.default)(this.tooltip_options[range]) === 'object') {
	          var rangeLabel = this.tooltip_options[range].label;
	          this.$emit('image-label-changed', rangeLabel + ' : ' + optionLabel);
	        }
	      }
	
	      var dataEmit = {};
	      dataEmit[this.name] = { newValue: newValue };
	      this.$emit('value-changed', dataEmit);
	    },
	
	    hiddenValues: function hiddenValues(newValue, oldValue) {
	      for (var index in newValue) {
	        if (newValue[index] === this.selected) {
	          this.selected = '';
	        }
	      }
	    },
	
	    disabledValues: function disabledValues(newValue, oldValue) {
	      for (var index in newValue) {
	        if (newValue[index] === this.selected) {
	          this.selected = '';
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'simple-choice',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    label: {
	      type: String,
	      default: ''
	    },
	    options: {
	      type: [Array, Object],
	      default: { imageUrl: '#', label: '', range: '', imageZoomUrl: '#' }
	    },
	    defaultField: {
	      type: [String, Number],
	      default: null
	    },
	    tooltip_options: {
	      type: [Array, Object],
	      default: function _default() {
	        return {};
	      }
	    },
	    hiddenValues: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    disabledValues: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      selected: null,
	      overElementKey: null
	    };
	  },
	  created: function created() {
	    this.selected = this.defaultField;
	  },
	  components: {},
	  computed: {},
	  methods: {
	    isHoverImage: function isHoverImage(index) {
	      return this.overElementKey === index;
	    },
	
	    setOverElementKey: function setOverElementKey(index) {
	      this.overElementKey = index;
	    },
	
	    showElement: function showElement(elementRef, element) {
	      return this.isHiddenElement(elementRef, element) === false && this.isDisabledElement(elementRef, element) === false;
	    },
	
	    isHiddenElement: function isHiddenElement(elementRef, element) {
	      if (typeof element.range !== 'undefined') {
	        return _common2.default.arrayContain(this.hiddenValues, elementRef) || _common2.default.arrayContain(this.hiddenValues, element.range);
	      } else {
	        return _common2.default.arrayContain(this.hiddenValues, elementRef);
	      }
	    },
	
	    isDisabledElement: function isDisabledElement(elementRef, element) {
	      if (typeof element.range !== 'undefined') {
	        return _common2.default.arrayContain(this.disabledValues, elementRef) || _common2.default.arrayContain(this.disabledValues, element.range);
	      } else {
	        return _common2.default.arrayContain(this.disabledValues, elementRef);
	      }
	    },
	
	    getTooltipHeaderLabel: function getTooltipHeaderLabel(range) {
	      if (typeof this.tooltip_options[range] !== 'undefined') {
	        return this.tooltip_options[range].label;
	      }
	      return '';
	    }
	  },
	  watch: {
	    defaultField: function defaultField(newValue, oldValue) {
	      this.selected = newValue;
	    },
	
	    selected: function selected(newValue, oldValue) {
	      var element = null;
	
	      for (var index in this.options) {
	        if (index === newValue) {
	          element = { key: index, value: this.options[index] };
	        }
	      }
	      if (element && (!this.showElement(element.key, element.value) || element.value.outOfStock)) {
	        this.selected = oldValue;
	        return;
	      }
	
	      var dataEmit = {};
	      dataEmit[this.name] = { newValue: newValue };
	
	      if ((0, _typeof3.default)(this.options[newValue]) === 'object') {
	        var optionLabel = this.options[newValue].label;
	        var range = this.options[newValue].range;
	        if ((0, _typeof3.default)(this.tooltip_options[range]) === 'object') {
	          var rangeLabel = this.tooltip_options[range].label;
	          this.$emit('image-label-changed', rangeLabel + ' : ' + optionLabel);
	        }
	      }
	
	      this.$emit('value-changed', dataEmit);
	    },
	
	    hiddenValues: function hiddenValues(newValue, oldValue) {
	      for (var index in newValue) {
	        if (newValue[index] === this.selected) {
	          this.selected = '';
	        }
	      }
	    },
	
	    disabledValues: function disabledValues(newValue, oldValue) {
	      for (var index in newValue) {
	        if (newValue[index] === this.selected) {
	          this.selected = '';
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'simple-choice',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    options: {
	      type: [Array, Object],
	      default: { label: '', display: true, disabled: false }
	    },
	    defaultField: {
	      type: [String, Number],
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selected: null
	    };
	  },
	  created: function created() {
	    this.selected = this.defaultField;
	  },
	  watch: {
	    selected: function selected(newValue, oldValue) {
	      var dataEmit = newValue;
	      this.$emit('value-changed', dataEmit);
	    },
	    defaultField: function defaultField(newValue, oldValue) {
	      this.selected = newValue;
	    }
	  }
	};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'select-with-picture-component',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    options: {
	      type: [Array, Object],
	      default: { label: '', display: true, disabled: false }
	    },
	    defaultField: {
	      type: [String, Number],
	      default: null
	    },
	    hideLabel: {
	      type: Boolean,
	      default: false
	    },
	    fullWidth: {
	      type: Boolean,
	      default: true
	    },
	    cssClasses: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      selected: null
	    };
	  },
	  created: function created() {
	    this.selected = this.defaultField;
	  },
	  watch: {
	    selected: function selected(newValue, oldValue) {
	      var dataEmit = newValue;
	      this.$emit('value-changed', dataEmit);
	    },
	    defaultField: function defaultField(newValue, oldValue) {
	      this.selected = newValue;
	    }
	  },
	  methods: {
	    checkLegacyOptions: function checkLegacyOptions(opt) {
	      var legacyOptions = ['OPT-249_fixations-plafond', 'OPT-250_equerre-80-160-mm', 'OPT-251_fixations-plafond', 'OPT-252_equerres-60-108-mm', 'OPT-253_equerres-108-156-mm'];
	      return !legacyOptions.includes(opt);
	    },
	    checkLabelVisibility: function checkLabelVisibility(optRef) {
	      if (this.hideLabel) {
	        switch (optRef) {
	          case 'OPT-1219_sangle':
	          case 'OPT-1220_treuil':
	          case 'OPT-1221_tirage-direct-avec-verrou':
	            return true;
	          default:
	            return false;
	        }
	      }
	      return true;
	    }
	  }
	};

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'select-with-text-component',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    },
	    options: {
	      type: [Array, Object],
	      default: { label: '', display: true, disabled: false }
	    },
	    defaultField: {
	      type: [String, Number],
	      default: null
	    },
	    cssClasses: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      selected: null
	    };
	  },
	  created: function created() {
	    this.selected = this.defaultField;
	  },
	  watch: {
	    selected: function selected(newValue, oldValue) {
	      var dataEmit = newValue;
	      this.$emit('value-changed', dataEmit);
	    },
	    defaultField: function defaultField(newValue, oldValue) {
	      this.selected = newValue;
	    }
	  },
	  methods: {}
	};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'modal',
	  props: {
	    name: {
	      type: String,
	      default: 'GalleryModal'
	    },
	    isDisplayed: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {};
	  },
	  components: {},
	  methods: {
	    closeModal: function closeModal() {
	      this.$emit('close-modal');
	    }
	  }
	};

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'label-component',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    text: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'range-component',
	  props: {
	    min: {
	      type: [Number, String],
	      default: 0
	    },
	    max: {
	      type: [Number, String],
	      default: 10
	    },
	    uom: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    rangeHumanized: function rangeHumanized() {
	      if (this.uom === '') {
	        return '(' + this.min + ' - ' + this.max + ')';
	      } else {
	        return '(' + this.min + ' - ' + this.max + ' ' + this.uom + ')';
	      }
	    }
	  }
	};

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'range-component',
	  props: {
	    min: {
	      type: [Number, String],
	      default: 0
	    },
	    max: {
	      type: [Number, String],
	      default: 10
	    },
	    uom: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  computed: {
	    rangeHumanized: function rangeHumanized() {
	      if (this.uom === '') {
	        return '(Min ' + this.min + ' / Max ' + this.max + ')';
	      } else {
	        return '(Min ' + this.min + ' ' + this.uom + ' / Max ' + this.max + ' ' + this.uom + ')';
	      }
	    }
	  }
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'text-component',
	  props: {
	    text: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'modal',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    tooltip: {
	      type: String,
	      default: ''
	    }
	  },
	  data: function data() {
	    return {
	      visible: false
	    };
	  },
	  components: {},
	  methods: {
	    toggle: function toggle() {
	      this.visible = !this.visible;
	    },
	
	    closeModal: function closeModal() {
	      this.visible = false;
	    }
	  }
	};

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'tooltip',
	  props: {
	    header: {
	      type: String,
	      default: ''
	    },
	    image: {
	      type: String,
	      default: '#'
	    },
	    footer: {
	      type: String,
	      default: ''
	    },
	    isDisplayed: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {};
	  },
	
	  methods: {}
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(49);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _zoom = __webpack_require__(51);
	
	var _zoom2 = _interopRequireDefault(_zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'zoom-in-place',
	  props: {
	    image: {
	      type: String,
	      default: ''
	    },
	    isDisplayed: {
	      type: Boolean,
	      default: false
	    },
	    onClick: {
	      type: Function,
	      default: function _default() {}
	    }
	  },
	  data: function data() {
	    return {
	      zoomStyle: {}
	    };
	  },
	  components: {},
	  methods: (0, _assign2.default)({}, _zoom2.default, {
	    setZoomOnItself: function setZoomOnItself() {
	      _vue2.default.set(this.zoomStyle, 'background-image', 'url("' + this.image + '")');
	      _vue2.default.set(this.zoomStyle, 'background-repeat', 'no-repeat');
	      _vue2.default.set(this.zoomStyle, 'background-size', '200%');
	      _vue2.default.set(this.zoomStyle, 'background-position', Math.max(-this.event.original_size.x, -this.event.position.x * 2) + 'px ' + Math.max(-this.event.original_size.y, -this.event.position.y * 2) + 'px');
	    }
	  }),
	  watch: {}
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _vue = __webpack_require__(49);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _zoom = __webpack_require__(51);
	
	var _zoom2 = _interopRequireDefault(_zoom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'zoom-separated',
	  props: {
	    image: {
	      type: String,
	      default: ''
	    },
	    isDisplayed: {
	      type: Boolean,
	      default: false
	    },
	    onClick: {
	      type: Function,
	      default: function _default() {}
	    },
	    firstPosition: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      over: false,
	      zoomStyle: {},
	      event: null,
	      MaxSizeBG: null
	    };
	  },
	  components: {},
	  computed: {
	    isActive: function isActive() {
	      return this.isDisplayed || this.over;
	    }
	  },
	  methods: (0, _assign2.default)({}, _zoom2.default, {
	    setZoomOnItself: function setZoomOnItself() {
	      if (this.MaxSizeBG == null && this.isActive && this.$el && this.$el.querySelector) {
	        var ratio = 1;
	
	        if (this.event.original_size.x < this.event.original_size.y) {
	          ratio = this.$el.querySelector('.zoom-overlay').clientWidth * this.event.original_size.y / this.event.original_size.x - this.$el.querySelector('.zoom-overlay').clientHeight;
	
	          this.MaxSizeBG = {
	            x: this.$el.querySelector('.zoom-overlay').clientWidth,
	            y: this.$el.querySelector('.zoom-overlay').clientHeight + 2 * ratio
	          };
	        } else {
	          ratio = this.$el.querySelector('.zoom-overlay').clientHeight * this.event.original_size.x / this.event.original_size.y - this.$el.querySelector('.zoom-overlay').clientWidth;
	
	          this.MaxSizeBG = {
	            x: this.$el.querySelector('.zoom-overlay').clientWidth + 2 * ratio,
	            y: this.$el.querySelector('.zoom-overlay').clientHeight
	          };
	        }
	      }
	
	      if (this.MaxSizeBG) {
	        _vue2.default.set(this.zoomStyle, 'background-image', 'url("' + this.image + '")');
	        _vue2.default.set(this.zoomStyle, 'background-repeat', 'no-repeat');
	        _vue2.default.set(this.zoomStyle, 'background-size', '200%');
	        _vue2.default.set(this.zoomStyle, 'background-position', Math.max(-this.MaxSizeBG.x, -this.event.position.x * this.MaxSizeBG.x / (this.event.original_size.x - this.event.size)) + 'px ' + Math.max(-this.MaxSizeBG.y, -this.event.position.y * this.MaxSizeBG.y / (this.event.original_size.y - this.event.size)) + 'px');
	      }
	    }
	  }),
	  watch: {
	    image: function image(newValue, oldValue) {
	      this.MaxSizeBG = null;
	      this.zoomStyle = {};
	      this.event = null;
	    },
	
	    firstPosition: function firstPosition(newValue, oldValue) {
	      if (newValue) {
	        this.over = true;
	        this.setupZoom(newValue);
	      }
	    }
	  }
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'gallery-block',
	  props: {
	    imageList: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    return {
	      selected: null
	    };
	  },
	
	  created: function created() {
	    if (this.imageList.length) {
	      this.selected = this.imageList[0];
	    }
	  },
	  components: _global2.default.rendering_units,
	  computed: {},
	  watch: {
	    imageList: function imageList(newValue, oldValue) {
	      if (newValue.length) {
	        this.selected = newValue[0];
	      } else {
	        this.selected = null;
	      }
	    }
	  },
	  methods: {
	    selectImage: function selectImage(data) {
	      this.selected = data;
	    }
	  }
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(56);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(21);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__(28);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _translationFr = __webpack_require__(15);
	
	var _translationFr2 = _interopRequireDefault(_translationFr);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _SelectionPictureHandleSide = __webpack_require__(313);
	
	var _SelectionPictureHandleSide2 = _interopRequireDefault(_SelectionPictureHandleSide);
	
	var _SelectionPictureFixation = __webpack_require__(312);
	
	var _SelectionPictureFixation2 = _interopRequireDefault(_SelectionPictureFixation);
	
	var _SelectionPictureBandeSize = __webpack_require__(311);
	
	var _SelectionPictureBandeSize2 = _interopRequireDefault(_SelectionPictureBandeSize);
	
	var _SelectionPictureBandeFold = __webpack_require__(310);
	
	var _SelectionPictureBandeFold2 = _interopRequireDefault(_SelectionPictureBandeFold);
	
	var _SelectionPictureBox = __webpack_require__(314);
	
	var _SelectionPictureBox2 = _interopRequireDefault(_SelectionPictureBox);
	
	var _SelectionPictureInstallation = __webpack_require__(317);
	
	var _SelectionPictureInstallation2 = _interopRequireDefault(_SelectionPictureInstallation);
	
	var _SelectionPictureOptSecu = __webpack_require__(319);
	
	var _SelectionPictureOptSecu2 = _interopRequireDefault(_SelectionPictureOptSecu);
	
	var _SelectionPictureCommande = __webpack_require__(315);
	
	var _SelectionPictureCommande2 = _interopRequireDefault(_SelectionPictureCommande);
	
	var _SelectionPictureOptCommande = __webpack_require__(318);
	
	var _SelectionPictureOptCommande2 = _interopRequireDefault(_SelectionPictureOptCommande);
	
	var _SelectionPictureCoteCommande = __webpack_require__(316);
	
	var _SelectionPictureCoteCommande2 = _interopRequireDefault(_SelectionPictureCoteCommande);
	
	var _Selection = __webpack_require__(74);
	
	var _Selection2 = _interopRequireDefault(_Selection);
	
	var _lodash = __webpack_require__(265);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'virtual-form',
	  props: {
	    recipe: {
	      type: Object,
	      default: {}
	    },
	    bundle: {
	      type: Object,
	      default: {}
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    },
	    debug: {
	      type: Boolean,
	      default: false
	    },
	    isMobile: {
	      type: Boolean,
	      default: false
	    }
	  },
	  data: function data() {
	    return {
	      PRD_14: 'PRD-14_store-californien',
	      PRD_44: 'PRD-44_volet-roulant-rnovation-new',
	      B_VERSION: 'B',
	      cc: {},
	      timer: {},
	      fields: {},
	      validation: {},
	      humanized: {},
	      linkedFields: {},
	      formCaliFieldsGroupe: [{
	        key: 'INSTALLATION',
	        label: _translationFr2.default.abTest.prd14.variationB.fieldsGroup.INSTALLATION,
	        accordion: {
	          open: false
	        },
	        items: []
	      }, {
	        key: 'LARGEURDEBANDES',
	        label: _translationFr2.default.abTest.prd14.variationB.fieldsGroup.LARGEURDEBANDES,
	        accordion: {
	          open: false
	        },
	        items: []
	      }, {
	        key: 'DIMENSIONSDUSTORE',
	        label: _translationFr2.default.abTest.prd14.variationB.fieldsGroup.DIMENSIONSDUSTORE,
	        accordion: {
	          open: true
	        },
	        items: []
	      }, {
	        key: 'COLORIS',
	        label: _translationFr2.default.abTest.prd14.variationB.fieldsGroup.COLORIS,
	        accordion: {
	          open: true
	        },
	        items: []
	      }, {
	        key: 'MECANISME',
	        label: _translationFr2.default.abTest.prd14.variationB.fieldsGroup.MECANISME,
	        accordion: {
	          open: false
	        },
	        items: []
	      }],
	      formVoletRoulantFieldsGroupe: [{
	        key: 'DIMENSIONSDUVOLET',
	        label: _translationFr2.default.abTest.prd44.variationB.fieldsGroup.DIMENSIONS,
	        accordion: {
	          open: true
	        },
	        items: []
	      }, {
	        key: 'COLORIS',
	        label: _translationFr2.default.abTest.prd44.variationB.fieldsGroup.COLORIS,
	        accordion: {
	          open: true
	        },
	        items: []
	      }, {
	        key: 'COFFRE',
	        label: _translationFr2.default.abTest.prd44.variationB.fieldsGroup.COFFRE,
	        accordion: {
	          open: false
	        },
	        items: []
	      }, {
	        key: 'INSTALLATION',
	        label: _translationFr2.default.abTest.prd44.variationB.fieldsGroup.INSTALLATION,
	        accordion: {
	          open: false
	        },
	        items: []
	      }, {
	        key: 'COMMANDE',
	        label: _translationFr2.default.abTest.prd44.variationB.fieldsGroup.COMMANDE,
	        accordion: {
	          open: true
	        },
	        items: []
	      }, {
	        key: 'OPTSECU',
	        label: _translationFr2.default.abTest.prd44.variationB.fieldsGroup.OPTSECU,
	        accordion: {
	          open: false
	        },
	        items: []
	      }, {
	        key: 'ABTEST',
	        label: _translationFr2.default.abTest.prd44.variationB.fieldsGroup.ABTEST,
	        accordion: {
	          open: true
	        },
	        hidden: true,
	        items: []
	      }]
	    };
	  },
	
	  components: _global2.default.rendering_units,
	
	  computed: {
	    colorPickerErrorSummary: function colorPickerErrorSummary() {
	      var config = this.bundle.config_1 || {};
	      var errors = ((config.validation || {}).errors || [])['CH-143_coloris-1'] || [];
	      var msg = '';
	      switch (this.cc.config_1.prefilled_values['CH-142_type-de-store']) {
	        case 'OPT-231_store-1-couleur':
	        case 'OPT-232_store-2-couleurs':
	        case 'OPT-233_store-3-couleurs':
	          msg = errors.join('<br/>');
	      }
	      return msg !== '' ? msg : _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.noColorsSelected;
	    },
	    vrColorPickerErrorSummary: function vrColorPickerErrorSummary() {
	      var errors = ((this.validation || {}).errors || [])['CH-461_coloris'] || [];
	      return errors.join('<br/>');
	    },
	    getWidthField: function getWidthField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-136_largeur'], { chKey: 'CH-136_largeur' });
	    },
	    getHeightField: function getHeightField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-137_hauteur'], { chKey: 'CH-137_hauteur' });
	    },
	    getRailTypeField: function getRailTypeField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-146_type-de-rail'], { chKey: 'CH-146_type-de-rail' });
	    },
	    getRailColorField: function getRailColorField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-147_couleur-de-rail-classique'], { chKey: 'CH-147_couleur-de-rail-classique' });
	    },
	    isAbtested: function isAbtested() {
	      return this.version === this.B_VERSION && this.productReference === this.PRD_14;
	    },
	    isVrAbtested: function isVrAbtested() {
	      return this.version === this.B_VERSION && this.productReference === this.PRD_44;
	    },
	    getFilterField: function getFilterField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-143_coloris-1'].filters['FIL-9_coloris'], { chKey: 'FIL-9_coloris' });
	    },
	    getColorisAField: function getColorisAField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-143_coloris-1'], { chKey: 'CH-143_coloris-1' });
	    },
	    getColorisBField: function getColorisBField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-144_coloris-2'], { chKey: 'CH-144_coloris-2' });
	    },
	    getColorisCField: function getColorisCField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-145_coloris-3'], { chKey: 'CH-145_coloris-3' });
	    },
	    getTotalColorVariationField: function getTotalColorVariationField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-142_type-de-store'], { chKey: 'CH-142_type-de-store' });
	    },
	    productReference: function productReference() {
	      if ((0, _typeof3.default)(this.cc.config_1) === 'object') {
	        if (typeof this.cc.config_1.product_reference === 'string') {
	          return this.cc.config_1.product_reference;
	        }
	      }
	      return null;
	    },
	    getVrWidthField: function getVrWidthField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-459_largeur'], { chKey: 'CH-459_largeur' });
	    },
	    getVrHeightField: function getVrHeightField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-460_hauteur'], { chKey: 'CH-460_hauteur' });
	    },
	    getCaliDimLabels: function getCaliDimLabels() {
	      return (0, _assign2.default)({}, { 'widthLabel': _translationFr2.default.abTest.prd14.variationB.fields.dimension.width.label }, { 'widthSubtitle': _translationFr2.default.abTest.prd14.variationB.fields.dimension.width.subtitle }, { 'heightLabel': _translationFr2.default.abTest.prd14.variationB.fields.dimension.height.label }, { 'heightSubtitle': _translationFr2.default.abTest.prd14.variationB.fields.dimension.height.subtitle });
	    },
	    getVrDimLabels: function getVrDimLabels(tst) {
	      return (0, _assign2.default)({}, { 'widthLabel': _translationFr2.default.abTest.prd44.variationB.fields.dimension.width.label }, { 'widthSubtitle': _translationFr2.default.abTest.prd44.variationB.fields.dimension.width.subtitle }, { 'heightLabel': _translationFr2.default.abTest.prd44.variationB.fields.dimension.height.label }, { 'heightSubtitle': _translationFr2.default.abTest.prd44.variationB.fields.dimension.height.subtitle });
	    },
	    getVrColorisAField: function getVrColorisAField() {
	      return (0, _assign2.default)({}, this.filterRecipeFieldsMethod()['CH-461_coloris'], { chKey: 'CH-461_coloris' });
	    },
	
	    filterRecipeFields: function filterRecipeFields() {
	      return this.filterRecipeFieldsMethod();
	    },
	
	    getCc: function getCc() {
	      return this.cc;
	    }
	  },
	
	  watch: {
	    bundle: function bundle(newValue, oldValue) {
	      if (typeof newValue.config_1.humanized !== 'undefined') {
	        this.humanized = newValue.config_1.humanized;
	      }
	      if (typeof newValue.config_1.validation !== 'undefined') {
	        this.validation = newValue.config_1.validation;
	        this.cleanValidationInField();
	        this.ventilateValidationInFields(this.validation);
	        this.ventilateFieldValueHiddenDisable(this.validation);
	        var beforeCC = (0, _stringify2.default)(this.cc);
	        this.cc = this.cleanCc(this.cc);
	        if (beforeCC !== (0, _stringify2.default)(this.cc)) {
	          this.$emit('cc-changed', this.convertCcToUom(_common2.default.cloneDataObject(this.cc)));
	        }
	      }
	    },
	
	    recipe: function recipe(newValue, oldValue) {
	      this.fields = newValue.fields;
	      this.mapLinkedFields(newValue.fields);
	      if (typeof newValue.humanized !== 'undefined') {
	        this.humanized = newValue.humanized;
	      }
	      if (typeof newValue.validation !== 'undefined') {
	        this.validation = newValue.validation;
	        this.cleanValidationInField();
	        this.ventilateValidationInFields(this.validation);
	        this.ventilateFieldValueHiddenDisable(this.validation);
	      }
	      this.buildNewCc(newValue);
	    },
	
	    cc: function cc(newValue, oldValue) {
	      var vue = this;
	      var newCC = this.convertCcToUom(_common2.default.cloneDataObject(newValue));
	      newCC = this.cleanCc(newCC);
	      clearTimeout(this.timer);
	      this.timer = setTimeout(function () {
	        vue.$emit('cc-changed', newCC);
	      }, 500);
	    }
	  },
	
	  methods: {
	    getDimInfo: function getDimInfo(prd) {
	      switch (prd) {
	        case this.PRD_44:
	          return (0, _assign2.default)({}, { 'widthFieldRef': 'CH-459_largeur' }, { 'heightFieldRef': 'CH-460_hauteur' }, { 'widthLabel': _translationFr2.default.abTest.prd44.variationB.fields.dimension.width.label }, { 'widthSubtitle': _translationFr2.default.abTest.prd44.variationB.fields.dimension.width.subtitle }, { 'heightLabel': _translationFr2.default.abTest.prd44.variationB.fields.dimension.height.label }, { 'heightSubtitle': _translationFr2.default.abTest.prd44.variationB.fields.dimension.height.subtitle }, { 'docLink': 'https://cdn.stores-discount.com/pdf_stores_discount/notice-prise-de-mesure-volet-roulant-renovation.pdf' });
	        default:
	          return (0, _assign2.default)({}, { 'widthFieldRef': 'CH-136_largeur' }, { 'heightFieldRef': 'CH-137_hauteur' }, { 'widthLabel': _translationFr2.default.abTest.prd14.variationB.fields.dimension.width.label }, { 'widthSubtitle': _translationFr2.default.abTest.prd14.variationB.fields.dimension.width.subtitle }, { 'heightLabel': _translationFr2.default.abTest.prd14.variationB.fields.dimension.height.label }, { 'heightSubtitle': _translationFr2.default.abTest.prd14.variationB.fields.dimension.height.subtitle }, { 'docLink': 'https://cdn.stores-discount.com/pdf_stores_discount/stores-californien/notice-prise-de-mesure-stores-californiens.pdf' });
	      }
	    },
	    colorPickerHasError: function colorPickerHasError() {
	      switch (this.cc.config_1.prefilled_values['CH-142_type-de-store']) {
	        case 'OPT-231_store-1-couleur':
	          return !this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-143_coloris-1', this.cc.config_1.prefilled_values['CH-143_coloris-1']));
	        case 'OPT-232_store-2-couleurs':
	          return !(this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-143_coloris-1', this.cc.config_1.prefilled_values['CH-143_coloris-1'])) && this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-144_coloris-2', this.cc.config_1.prefilled_values['CH-144_coloris-2'])));
	        case 'OPT-233_store-3-couleurs':
	          return !(this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-143_coloris-1', this.cc.config_1.prefilled_values['CH-143_coloris-1'])) && this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-144_coloris-2', this.cc.config_1.prefilled_values['CH-144_coloris-2'])) && this.colorPictureStyleBackground(this.getRelatedColorPicture('CH-145_coloris-3', this.cc.config_1.prefilled_values['CH-145_coloris-3'])));
	      }
	      return false;
	    },
	    vrColorPickerHasError: function vrColorPickerHasError() {
	      return ((this.validation || {}).errors || [])['CH-461_coloris'] || false;
	    },
	    colorPictureStyleBackground: function colorPictureStyleBackground(url) {
	      if (url) {
	        return 'url(' + url + ') no-repeat -3px -3px';
	      } else {
	        return false;
	      }
	    },
	    getRelatedColorPicture: function getRelatedColorPicture(fieldKey, colorKey) {
	      if (this.recipe.fields) {
	        var field = this.recipe.fields[fieldKey];
	        if (field) {
	          var color = this.recipe.fields[fieldKey].values[colorKey];
	          if (color) {
	            return color.imageZoomUrl;
	          }
	        }
	      }
	      return false;
	    },
	    caliWidgetRailChanged: function caliWidgetRailChanged(event) {
	      var _this = this;
	
	      (0, _keys2.default)(event).forEach(function (key) {
	        _this.fieldHasChanged((0, _defineProperty3.default)({}, key, {
	          newValue: event[key]
	        }));
	      });
	    },
	    filterRecipeGroupedFields: function filterRecipeGroupedFields() {
	      var rawResult = this.filterRecipeFieldsMethod();
	      var formCaliFieldsGroupeHydrated = (0, _keys2.default)(rawResult).reduce(function (reduced, key) {
	        var tmpItem = null;
	        switch (key) {
	          case 'CH-151_type-douverture':
	            tmpItem = rawResult[key];
	            tmpItem.weight = 102;
	            tmpItem.fieldKey = key;
	            reduced[0].items[reduced[0].items.length] = tmpItem;
	            break;
	          case 'CH-152_ct-de-commande':
	            tmpItem = rawResult[key];
	            tmpItem.weight = 103;
	            tmpItem.fieldKey = key;
	            reduced[0].items[reduced[0].items.length] = tmpItem;
	            break;
	          case 'CH-154_fixations-rail-classique':
	            tmpItem = rawResult[key];
	            tmpItem.weight = 101;
	            tmpItem.fieldKey = key;
	            reduced[0].items[reduced[0].items.length] = tmpItem;
	            break;
	
	          case 'CH-138_largeur-de-bandes':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            reduced[1].items[reduced[1].items.length] = tmpItem;
	            break;
	
	          case 'CH-136_largeur':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 101;
	            reduced[2].items[reduced[2].items.length] = tmpItem;
	            break;
	          case 'CH-137_hauteur':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 102;
	            reduced[2].items[reduced[2].items.length] = tmpItem;
	            break;
	
	          case 'CH-143_coloris-1':
	          case 'CH-144_coloris-2':
	          case 'CH-145_coloris-3':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            reduced[3].items[reduced[3].items.length] = tmpItem;
	            break;
	
	          case 'CH-146_type-de-rail':
	          case 'CH-147_couleur-de-rail-classique':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            reduced[4].items[reduced[4].items.length] = tmpItem;
	            break;
	          default:
	            break;
	        }
	        return reduced;
	      }, _common2.default.cloneDataObject(this.formCaliFieldsGroupe));
	      formCaliFieldsGroupeHydrated[0].items = _lodash2.default.orderBy(formCaliFieldsGroupeHydrated[0].items, 'weight');
	      var result = formCaliFieldsGroupeHydrated.map(function (groupe, pos) {
	        groupe.items = _lodash2.default.orderBy(groupe.items, 'weight');
	        return groupe;
	      });
	
	      return result;
	    },
	    VoletRoulantFilterRecipeGroupedFields: function VoletRoulantFilterRecipeGroupedFields() {
	      var rawResult = this.filterRecipeFieldsMethod();
	      var formVrFieldsGroupeHydrated = (0, _keys2.default)(rawResult).reduce(function (reduced, key) {
	        var tmpItem = null;
	        switch (key) {
	          case 'CH-459_largeur':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 100;
	            reduced[0].items[reduced[0].items.length] = tmpItem;
	            break;
	          case 'CH-460_hauteur':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 101;
	            reduced[0].items[reduced[0].items.length] = tmpItem;
	            break;
	          case 'CH-461_coloris':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 102;
	            reduced[1].items[reduced[1].items.length] = tmpItem;
	            break;
	          case 'CH-457_type-de-coffre':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 103;
	            reduced[2].items[reduced[2].items.length] = tmpItem;
	            break;
	          case 'CH-465_type-de-pose':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 104;
	            reduced[3].items[reduced[3].items.length] = tmpItem;
	            break;
	          case 'CH-469_commande':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 105;
	            reduced[4].items[reduced[4].items.length] = tmpItem;
	            break;
	          case 'CH-470_option-de-commande':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 106;
	            reduced[4].items[reduced[4].items.length] = tmpItem;
	            break;
	          case 'CH-464_ct-de-commande':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 107;
	            reduced[4].items[reduced[4].items.length] = tmpItem;
	            break;
	          case 'CH-467_anti-vol':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 108;
	            reduced[5].items[reduced[5].items.length] = tmpItem;
	            break;
	
	          case 'CH-616_filtre-commande':
	          case 'CH-622_filtre-commande':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 109;
	            reduced[6].items[reduced[6].items.length] = tmpItem;
	            break;
	          case 'CH-614_version-fiche-produit':
	          case 'CH-620_version-fiche-produit':
	            tmpItem = rawResult[key];
	            tmpItem.fieldKey = key;
	            tmpItem.weight = 110;
	            reduced[6].items[reduced[6].items.length] = tmpItem;
	            break;
	          default:
	            break;
	        }
	        return reduced;
	      }, _common2.default.cloneDataObject(this.formVoletRoulantFieldsGroupe));
	      formVrFieldsGroupeHydrated[0].items = _lodash2.default.orderBy(formVrFieldsGroupeHydrated[0].items, 'weight');
	      var result = formVrFieldsGroupeHydrated.map(function (groupe, pos) {
	        groupe.items = _lodash2.default.orderBy(groupe.items, 'weight');
	        return groupe;
	      });
	      return result;
	    },
	    groupedFieldSummary: function groupedFieldSummary(groupedFieldKey, prdRef) {
	      var _this2 = this;
	
	      var ccItems = prdRef === this.PRD_44 ? this.VoletRoulantFilterRecipeGroupedFields() : this.filterRecipeGroupedFields();
	      var fields = ccItems.find(function (item) {
	        return item.key === groupedFieldKey;
	      }).items;
	      return fields.reduce(function (reduced, field) {
	        if (typeof _this2.humanized[field.label] !== 'undefined') {
	          var relatedFieldError = '';
	          if (typeof _this2.validation !== 'undefined') {
	            if (typeof _this2.validation.errors !== 'undefined') {
	              relatedFieldError = [].concat((0, _toConsumableArray3.default)(_this2.validation.errors[field.fieldKey] || [])).join('');
	            }
	          }
	          var value = _this2.humanized[field.label];
	          if (field.fieldKey === 'CH-136_largeur' || field.fieldKey === 'CH-137_hauteur') {
	            value = _common2.default.toCm(parseInt(_this2.humanized[field.label]), 'mm') + ' cm';
	          }
	          if (field.fieldKey === 'CH-459_largeur' || field.fieldKey === 'CH-460_hauteur') {
	            value = _this2.humanized[field.label] + ' mm';
	          }
	
	          if (field.fieldKey === 'CH-464_ct-de-commande' && (_this2.cc.config_1.prefilled_values['CH-616_filtre-commande'] === 'OPT-2426_motorise-radio-commande' || _this2.cc.config_1.prefilled_values['CH-622_filtre-commande'] === 'OPT-2439_motorise-radio-commande')) {
	            field.label = 'Sortie électrique (vue de l\'intérieur)';
	            _this2.humanized[field.label] = 'Sortie électrique (vue de l\'intérieur)';
	            value = value.includes('gauche') ? 'à gauche' : 'à droite';
	          }
	          reduced.push({
	            key: field.fieldKey,
	            label: field.label + ' : ',
	            value: value,
	            error: relatedFieldError
	          });
	        }
	        return reduced;
	      }, []);
	    },
	    accordionToggle: function accordionToggle(key) {
	      var newformCaliFieldsGroupe = _common2.default.cloneDataObject(this.formCaliFieldsGroupe);
	      newformCaliFieldsGroupe.forEach(function (item, pos) {
	        if (item.key === key) {
	          newformCaliFieldsGroupe[pos].accordion.open = !newformCaliFieldsGroupe[pos].accordion.open;
	        }
	      });
	      this.formCaliFieldsGroupe = newformCaliFieldsGroupe;
	    },
	    accordionVrToggle: function accordionVrToggle(key) {
	      var newformVoletRoulantFieldsGroupe = _common2.default.cloneDataObject(this.formVoletRoulantFieldsGroupe);
	      newformVoletRoulantFieldsGroupe.forEach(function (item, pos) {
	        if (item.key === key) {
	          newformVoletRoulantFieldsGroupe[pos].accordion.open = !newformVoletRoulantFieldsGroupe[pos].accordion.open;
	        }
	      });
	      this.formVoletRoulantFieldsGroupe = newformVoletRoulantFieldsGroupe;
	    },
	    filterRecipeFieldsMethod: function filterRecipeFieldsMethod() {
	      var mapFieldSortedByWeight = [];
	      var i = 0;
	      for (var fieldKey in this.fields) {
	        if (typeof this.fields[fieldKey].accordion === 'undefined') {
	          this.fields[fieldKey].accordion = {
	            open: i === 0
	          };
	        }
	        var mapField = {};
	        mapField.key = fieldKey;
	        mapField.weight = this.fields[fieldKey].weight;
	        mapFieldSortedByWeight.push(mapField);
	        i++;
	      }
	
	      mapFieldSortedByWeight = _lodash2.default.sortBy(mapFieldSortedByWeight, 'weight');
	
	      var fieldsSortedByWeight = {};
	      for (var mapFieldPos in mapFieldSortedByWeight) {
	        fieldKey = mapFieldSortedByWeight[mapFieldPos].key;
	        fieldsSortedByWeight[fieldKey] = (0, _assign2.default)({}, this.fields[fieldKey]);
	      }
	      return fieldsSortedByWeight;
	    },
	
	    renderingUnitToLoad: function renderingUnitToLoad(field, fieldKey) {
	      if (this.version === this.B_VERSION && (this.productReference === this.PRD_14 || this.productReference === this.PRD_44)) {
	        switch (fieldKey) {
	          case 'CH-152_ct-de-commande':
	            return _SelectionPictureHandleSide2.default;
	          case 'CH-154_fixations-rail-classique':
	            return _SelectionPictureFixation2.default;
	          case 'CH-138_largeur-de-bandes':
	            return _SelectionPictureBandeSize2.default;
	          case 'CH-151_type-douverture':
	            return _SelectionPictureBandeFold2.default;
	          case 'CH-457_type-de-coffre':
	            return _SelectionPictureBox2.default;
	          case 'CH-465_type-de-pose':
	            return _SelectionPictureInstallation2.default;
	          case 'CH-469_commande':
	            return _SelectionPictureCommande2.default;
	          case 'CH-470_option-de-commande':
	            return _SelectionPictureOptCommande2.default;
	          case 'CH-464_ct-de-commande':
	            return _SelectionPictureCoteCommande2.default;
	          case 'CH-467_anti-vol':
	            return _SelectionPictureOptSecu2.default;
	          case 'CH-616_filtre-commande':
	          case 'CH-622_filtre-commande':
	            return _Selection2.default;
	          case 'CH-614_version-fiche-produit':
	          case 'CH-620_version-fiche-produit':
	            return _Selection2.default;
	        }
	      }
	      for (var index in _global2.default.rendering_unit_mapping) {
	        if (_global2.default.rendering_unit_mapping[index].name === field.elementType) {
	          if (fieldKey !== 'CH-616_filtre-commande' && fieldKey !== 'CH-622_filtre-commande') {
	            if (this.isMobile && typeof _global2.default.rendering_unit_mapping[index].rendering_unit_mobile !== 'undefined') {
	              return _global2.default.rendering_unit_mapping[index].rendering_unit_mobile;
	            } else {
	              return _global2.default.rendering_unit_mapping[index].rendering_unit;
	            }
	          }
	        }
	      }
	
	      return null;
	    },
	
	    convertCcToUom: function convertCcToUom(cc) {
	      for (var fieldKey in cc.config_1.prefilled_values) {
	        if (typeof this.fields[fieldKey] !== 'undefined') {
	          if (this.fields[fieldKey].elementType === 'size') {
	            cc.config_1.prefilled_values[fieldKey] = _common2.default.toMm(cc.config_1.prefilled_values[fieldKey], this.uom);
	          }
	        }
	      }
	      return cc;
	    },
	
	    fieldValueInCC: function fieldValueInCC(fieldKey) {
	      if (this.version !== this.B_VERSION && this.productReference === this.PRD_44) {
	        this.cc.config_1.prefilled_values['CH-614_version-fiche-produit'] = 'OPT-2402_classique';
	        this.cc.config_1.prefilled_values['CH-620_version-fiche-produit'] = 'OPT-2433_classique';
	        delete this.cc.config_1.prefilled_values['CH-616_filtre-commande'];
	        delete this.cc.config_1.prefilled_values['CH-622_filtre-commande'];
	      }
	      return this.cc.config_1.prefilled_values[fieldKey];
	    },
	
	    updateFieldInCC: function updateFieldInCC(cc, field) {
	      var fieldKeyUpdate = (0, _keys2.default)(field);
	      if (typeof field[fieldKeyUpdate] !== 'undefined') {
	        cc.config_1.prefilled_values[fieldKeyUpdate] = field[fieldKeyUpdate].newValue;
	      }
	      return cc;
	    },
	
	    cleanCc: function cleanCc(cc) {
	      var hiddenValues = _common2.default.returnAlwaysArray(this.validation.hidden_values);
	      var disabledValues = _common2.default.returnAlwaysArray(this.validation.disabled_values);
	      for (var fieldKey in cc.config_1.prefilled_values) {
	        if (typeof this.linkedFields[fieldKey] !== 'undefined') {
	          var linkedField = this.linkedFields[fieldKey];
	          var linkedFieldValue = cc.config_1.prefilled_values[linkedField];
	
	          if (_common2.default.arrayContain(hiddenValues, linkedFieldValue) || _common2.default.arrayContain(disabledValues, linkedFieldValue)) {
	            cc.config_1.prefilled_values[linkedField] = '';
	          }
	        } else {
	          if (typeof this.fields[fieldKey] !== 'undefined') {
	            if (this.fields[fieldKey].elementType === 'material') {
	              if (_common2.default.arrayContain(hiddenValues, fieldKey) || _common2.default.arrayContain(disabledValues, fieldKey)) {
	                cc.config_1.prefilled_values[fieldKey] = '';
	              }
	
	              var colorKey = cc.config_1.prefilled_values[fieldKey];
	              var color = _common2.default.returnAlwaysObject(this.fields[fieldKey].values[colorKey]);
	              var colorRange = color.range;
	              if (typeof colorRange !== 'undefined') {
	                if (_common2.default.arrayContain(hiddenValues, colorRange) || _common2.default.arrayContain(disabledValues, colorRange)) {
	                  cc.config_1.prefilled_values[fieldKey] = '';
	                }
	              }
	            }
	          }
	        }
	      }
	      return cc;
	    },
	
	    cleanValidationInField: function cleanValidationInField() {
	      var clonedFields = _common2.default.cloneDataObject(this.fields);
	      for (var fieldKey in clonedFields) {
	        try {
	          delete clonedFields[fieldKey].validation;
	        } catch (e) {}
	      }
	      this.fields = clonedFields;
	    },
	
	    ventilateValidationInFields: function ventilateValidationInFields(validation) {
	      var clonedFields = _common2.default.cloneDataObject(this.fields);
	
	      var validationMessageTypes = ['errors', 'warning', 'info'];
	      for (var validationMessageTypeKey in validationMessageTypes) {
	        var validationMessageType = validationMessageTypes[validationMessageTypeKey];
	        if (typeof validation[validationMessageType] !== 'undefined') {
	          for (var messageKey in validation[validationMessageType]) {
	            clonedFields[messageKey] = _common2.default.initiateObjectPropertyIfUndefined(clonedFields[messageKey], 'validation');
	            clonedFields[messageKey]['validation'][validationMessageType] = validation[validationMessageType][messageKey];
	          }
	        }
	      }
	
	      var validationDisplayTypes = ['hidden_values', 'disabled_values'];
	      for (var validationDisplayTypeKey in validationDisplayTypes) {
	        var validationDisplayType = validationDisplayTypes[validationDisplayTypeKey];
	        if (typeof validation[validationDisplayType] !== 'undefined') {
	          for (var displayKey in validation[validationDisplayType]) {
	            var displayFieldKey = validation[validationDisplayType][displayKey];
	
	            for (var field in clonedFields) {
	              if (displayFieldKey.indexOf(field) > -1) {
	                clonedFields[field] = _common2.default.initiateObjectPropertyIfUndefined(clonedFields[field], 'validation');
	                clonedFields[field]['validation'] = _common2.default.initiateArrayPropertyIfUndefined(clonedFields[field]['validation'], validationDisplayType);
	                clonedFields[field]['validation'][validationDisplayType].push(displayFieldKey);
	              }
	            }
	          }
	        }
	      }
	
	      this.fields = clonedFields;
	    },
	
	    ventilateFieldValueHiddenDisable: function ventilateFieldValueHiddenDisable(validation) {
	      var validationDisplayTypes = ['hidden_values', 'disabled_values'];
	      var clonedFields = _common2.default.cloneDataObject(this.fields);
	      for (var fieldKey in clonedFields) {
	        for (var optKey in clonedFields[fieldKey].values) {
	          for (var validationDisplayTypeKey in validationDisplayTypes) {
	            var validationDisplayType = validationDisplayTypes[validationDisplayTypeKey];
	            var validationValues = _common2.default.returnAlwaysArray(validation[validationDisplayType]);
	
	            if (clonedFields[fieldKey].elementType === 'option') {
	              var optValue = clonedFields[fieldKey].values[optKey].value;
	              if (_common2.default.arrayContain(validationValues, optValue)) {
	                clonedFields[fieldKey] = _common2.default.initiateObjectPropertyIfUndefined(clonedFields[fieldKey], 'validation');
	                clonedFields[fieldKey]['validation'] = _common2.default.initiateArrayPropertyIfUndefined(clonedFields[fieldKey]['validation'], validationDisplayType);
	                clonedFields[fieldKey]['validation'][validationDisplayType].push(optValue);
	              }
	            }
	
	            if (clonedFields[fieldKey].elementType === 'material') {
	              var rangeValue = clonedFields[fieldKey].values[optKey].range;
	              if (_common2.default.arrayContain(validationValues, rangeValue)) {
	                clonedFields[fieldKey] = _common2.default.initiateObjectPropertyIfUndefined(clonedFields[fieldKey], 'validation');
	                clonedFields[fieldKey]['validation'] = _common2.default.initiateArrayPropertyIfUndefined(clonedFields[fieldKey]['validation'], validationDisplayType);
	                clonedFields[fieldKey]['validation'][validationDisplayType].push(rangeValue);
	              }
	            }
	          }
	        }
	      }
	
	      this.fields = clonedFields;
	    },
	
	    mapLinkedFields: function mapLinkedFields(fields) {
	      var linkedFields = {};
	      for (var fieldKey in fields) {
	        var field = fields[fieldKey];
	        if (typeof field.linkedField !== 'undefined') {
	          linkedFields[fieldKey] = field.linkedField;
	        }
	
	        if (typeof field.filters !== 'undefined') {
	          for (var filterKey in field.filters) {
	            if (typeof field.filters[filterKey].linkedField !== 'undefined') {
	              linkedFields[filterKey] = field.filters[filterKey].linkedField;
	            }
	          }
	        }
	      }
	      this.linkedFields = linkedFields;
	    },
	
	    buildNewCc: function buildNewCc(recipe) {
	      var config = {
	        config_1: {
	          product_reference: recipe.product_ref,
	          prefilled_values: {}
	        }
	      };
	
	      for (var fieldKey in recipe.fields) {
	        if (typeof recipe.fields[fieldKey].defaultVal !== 'undefined') {
	          var defaultValue = recipe.fields[fieldKey].defaultVal;
	          if (recipe.fields[fieldKey].elementType === 'size') {
	            defaultValue = _common2.default.convertUomToUom(defaultValue, 'mm', this.uom).toString();
	          }
	          config.config_1.prefilled_values[fieldKey] = defaultValue;
	        } else {
	          config.config_1.prefilled_values[fieldKey] = '';
	        }
	
	        if (typeof recipe.fields[fieldKey].filters !== 'undefined') {
	          for (var filterKey in recipe.fields[fieldKey].filters) {
	            config.config_1.prefilled_values[filterKey] = [];
	            for (var valueKey in recipe.fields[fieldKey].filters[filterKey].defaultVal) {
	              config.config_1.prefilled_values[filterKey].push(valueKey);
	            }
	          }
	        }
	      }
	
	      this.cc = config;
	    },
	
	    fieldIsNotHidden: function fieldIsNotHidden(fieldRef) {
	      if (_common2.default.arrayContain(this.validation.hidden_values, fieldRef)) {
	        if (this.fields[fieldRef].elementType === 'material') {
	          return false;
	        }
	      }
	      return true;
	    },
	
	    fieldHasChanged: function fieldHasChanged(field) {
	      this.cc = this.updateFieldInCC(_common2.default.cloneDataObject(this.cc), field);
	    },
	    show: function show(obj) {
	      console.log('===> Show ', obj);
	    },
	    abTestHiddenFields: function abTestHiddenFields(fieldKey) {
	      var hiddenFields = ['CH-614_version-fiche-produit', 'CH-616_filtre-commande', 'CH-620_version-fiche-produit', 'CH-622_filtre-commande'];
	      return hiddenFields.find(function (element) {
	        return element === fieldKey;
	      });
	    },
	
	    fieldIsVisible: function fieldIsVisible(fieldRef) {
	      return !_common2.default.arrayContain(this.validation.hidden_values, fieldRef);
	    },
	
	    isHiddenGroup: function isHiddenGroup(groupKey) {
	      if (groupKey === 'OPTSECU' && (this.cc.config_1.prefilled_values['CH-616_filtre-commande'] === 'OPT-2427_motorise-solaire' || this.cc.config_1.prefilled_values['CH-622_filtre-commande'] === 'OPT-2440_motorise-solaire' || this.cc.config_1.prefilled_values['CH-469_commande'] === 'OPT-1221_tirage-direct-avec-verrou')) {
	        return true;
	      }
	    }
	  }
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(21);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'data-logger',
	
	  props: ['data', 'name'],
	  data: function data() {
	    return {
	      toggle: false
	    };
	  },
	
	  computed: {
	    dataLength: function dataLength() {
	      return ['Data length', (0, _stringify2.default)(this.data).length, 'Char'].join(' ');
	    },
	
	    loggerTitle: function loggerTitle() {
	      var suffixTitle = 'logger';
	      if (this.name === '') {
	        return ['Data', suffixTitle].join(' ');
	      } else {
	        return this.name;
	      }
	    }
	  },
	  methods: {
	    toggleLogger: function toggleLogger() {
	      this.toggle = !this.toggle;
	    },
	
	    pasteToConsole: function pasteToConsole() {
	      console.log(this.data);
	    },
	
	    pasteToConsoleInJson: function pasteToConsoleInJson() {
	      console.log((0, _stringify2.default)(this.data));
	    }
	  }
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _dimension = __webpack_require__(27);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dimension',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', minValue: 0, maxValue: 100, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      val_uom: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _dimension.DimensionComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _dimension.DimensionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _dimension.DimensionWatch)
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _dimension = __webpack_require__(27);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dimension-mobile',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', minValue: 0, maxValue: 100, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      val_uom: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _dimension.DimensionComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _dimension.DimensionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _dimension.DimensionWatch)
	};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _dimension = __webpack_require__(27);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dimension-uom-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', minValue: 0, maxValue: 100, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      val_uom: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _dimension.DimensionComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _dimension.DimensionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _dimension.DimensionWatch)
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _gallery = __webpack_require__(52);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'gallery',
	  props: {
	    imageList: {
	      type: Array,
	      default: []
	    },
	    selectedImage: {
	      type: String,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selectedIndex: 0,
	      list: [],
	      displayZoom: false,
	      components: _global2.default.components,
	      positionOnImage: { x: 0, y: 0 } };
	  },
	
	  created: function created() {
	    _gallery.GalleryWatch.imageList(this.imageList, this.imageList);
	  },
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _gallery.GalleryComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _gallery.GalleryMethods, {}),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _gallery.GalleryWatch)
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _gallery = __webpack_require__(52);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'gallery-with-modal',
	  props: {
	    imageList: {
	      type: Array,
	      default: []
	    },
	    selectedImage: {
	      type: String,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selectedIndex: 0,
	      list: [],
	      displayZoom: false,
	      components: _global2.default.components,
	      modalDisplayed: false,
	      displayZoomInModal: false,
	      positionOnImage: { x: 0, y: 0 } };
	  },
	
	  created: function created() {
	    _gallery.GalleryWatch.imageList(this.imageList, this.imageList);
	  },
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _gallery.GalleryComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _gallery.GalleryMethods, {
	    toggleZoomModal: function toggleZoomModal() {
	      this.displayZoomInModal = !this.displayZoomInModal;
	    }
	  }),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _gallery.GalleryWatch)
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _material = __webpack_require__(53);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'material',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', range: {}, options: [], filters: {}, tooltip: '' }
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      overImage: null,
	      imageLabel: '',
	      filters: []
	    };
	  },
	
	  components: _global2.default.components,
	  created: function created() {
	    var toAppend = null;
	
	    for (var index in this.field.filters) {
	      if (index.indexOf('colori') !== -1) {
	        toAppend = {
	          key: index,
	          value: this.field.filters[index]
	        };
	      } else {
	        this.filters.push({
	          key: index,
	          value: this.field.filters[index]
	        });
	      }
	    }
	
	    if (toAppend) {
	      this.filters.push(toAppend);
	    }
	  },
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _material.MaterialComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _material.MaterialMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _material.MaterialWatch)
	};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _material = __webpack_require__(53);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'material-mobile',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', range: {}, options: [], filters: {} }
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      overImage: null,
	      imageLabel: '',
	      filters: []
	    };
	  },
	
	  components: _global2.default.components,
	  created: function created() {
	    var toAppend = null;
	
	    for (var index in this.field.filters) {
	      if (index.indexOf('colori') !== -1) {
	        toAppend = {
	          key: index,
	          value: this.field.filters[index],
	          closed: true
	        };
	      } else {
	        this.filters.push({
	          key: index,
	          value: this.field.filters[index],
	          closed: true
	        });
	      }
	    }
	
	    if (toAppend) {
	      this.filters.push(toAppend);
	    }
	  },
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _material.MaterialComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _material.MaterialMethods, {
	    toggleFilter: function toggleFilter(data) {
	      for (var index in this.filters) {
	        if (this.filters[index].key === data.name) {
	          this.filters[index].closed = !this.filters[index].closed;
	        }
	      }
	    }
	  }),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _material.MaterialWatch)
	};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-mobile',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _unit = __webpack_require__(34);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'unit',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _unit.UnitComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _unit.UnitMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _unit.UnitWatch)
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _unit = __webpack_require__(34);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'unit-mobile',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _unit.UnitComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _unit.UnitMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _unit.UnitWatch)
	};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _unit = __webpack_require__(34);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'init-uom-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _unit.UnitComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _unit.UnitMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _unit.UnitWatch)
	};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(55);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(54);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _translationFr = __webpack_require__(15);
	
	var _translationFr2 = _interopRequireDefault(_translationFr);
	
	var _FilterFieldWidget = __webpack_require__(75);
	
	var _FilterFieldWidget2 = _interopRequireDefault(_FilterFieldWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'color-picker-field-widget',
	  props: {
	
	    filter: {
	      type: Object,
	      default: {}
	    },
	    colorisA: {
	      type: Object,
	      default: {}
	    },
	    colorisB: {
	      type: Object,
	      default: {}
	    },
	    colorisC: {
	      type: Object,
	      default: {}
	    },
	    totalColorVariation: {
	      type: Object,
	      default: {}
	    },
	    cc: {
	      type: Object,
	      default: function _default() {
	        return {
	          config_1: {
	            prefilled_values: {
	              'CH-142_type-de-store': null,
	              'FIL-9_coloris': null,
	              'CH-143_coloris-1': null,
	              'CH-144_coloris-2': null,
	              'CH-145_coloris-3': null
	            }
	          }
	        };
	      }
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    fieldHasChanged: {
	      type: Function,
	      default: function _default() {}
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      totalColorVariationSelected: null,
	      colorASelected: null,
	      colorBSelected: null,
	      colorCSelected: null,
	      oneColorType: 'OPT-231_store-1-couleur',
	      twoColorType: 'OPT-232_store-2-couleurs',
	      threeColorType: 'OPT-233_store-3-couleurs',
	      colorASelectedSummary: {
	        range: '',
	        label: ''
	      },
	      colorBSelectedSummary: {
	        range: '',
	        label: ''
	      },
	      colorCSelectedSummary: {
	        range: '',
	        label: ''
	      }
	    };
	  },
	  created: function created() {
	    this.totalColorVariationSelected = this.cc.config_1.prefilled_values['CH-142_type-de-store'];
	    this.colorASelected = this.cc.config_1.prefilled_values['CH-143_coloris-1'];
	    this.colorBSelected = this.cc.config_1.prefilled_values['CH-144_coloris-2'];
	    this.colorCSelected = this.cc.config_1.prefilled_values['CH-145_coloris-3'];
	  },
	  components: {
	    FilterFieldWidget: _FilterFieldWidget2.default
	  },
	  computed: {
	    frText: function frText() {
	      return _translationFr2.default;
	    },
	    colorAFormated: function colorAFormated() {
	      return this.colorFormater(this.colorisA);
	    },
	    colorBFormated: function colorBFormated() {
	      return this.colorFormater(this.colorisB);
	    },
	    colorCFormated: function colorCFormated() {
	      return this.colorFormater(this.colorisC);
	    },
	    isOneColorType: function isOneColorType() {
	      return this.cc.config_1.prefilled_values['CH-142_type-de-store'] === this.oneColorType;
	    },
	    isTwoColorType: function isTwoColorType() {
	      return this.cc.config_1.prefilled_values['CH-142_type-de-store'] === this.twoColorType;
	    },
	    isThreeColorType: function isThreeColorType() {
	      return this.cc.config_1.prefilled_values['CH-142_type-de-store'] === this.threeColorType;
	    }
	  },
	  methods: {
	    checkColorErrors: function checkColorErrors(colorType) {
	      switch (colorType) {
	        case 'colorisB':
	          return (this.colorisB.validation.errors || []).join('<br/>');
	        case 'colorisC':
	          return (this.colorisC.validation.errors || []).join('<br/>');
	      }
	    },
	    isThisRange: function isThisRange(color, rangeKey) {
	      if (color) {
	        return color.range === rangeKey;
	      }
	      return false;
	    },
	    changeColorType: function changeColorType(colorTypeKey) {
	      if (this.totalColorVariationSelected === colorTypeKey) {
	        this.totalColorVariationSelected = '';
	      }
	      this.totalColorVariationSelected = colorTypeKey;
	    },
	    colorPictureStyleBackground: function colorPictureStyleBackground(url) {
	      var outOfStock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var imgOutOfStock = outOfStock ? "url('https://cdn.configurateur.stores-discount.com/matiere/rupture-neutre.png') no-repeat -1px," : '';
	      url = url.replace('\'', '-');
	      return imgOutOfStock + ' url(' + url + ') no-repeat -3px -3px';
	    },
	    colorByRangekey: function colorByRangekey(colorFormated, rangeKey) {
	      var _this = this;
	
	      return (0, _keys2.default)(colorFormated.values).reduce(function (reduced, colorKey) {
	        var color = colorFormated.values[colorKey];
	        if (color.range === rangeKey) {
	          if (!colorFormated.validation.hidden_values.find(function (hiddenRangeKey) {
	            return hiddenRangeKey === color.range;
	          })) {
	            if (_this.isVisible(colorKey, colorFormated)) {
	              reduced[colorKey] = color;
	            }
	          }
	        }
	        return reduced;
	      }, {});
	    },
	    sortObj: function sortObj(obj) {
	      return Object.fromEntries((0, _entries2.default)(obj).sort(function (_ref, _ref2) {
	        var _ref4 = (0, _slicedToArray3.default)(_ref, 2),
	            a = _ref4[1];
	
	        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	            b = _ref3[1];
	
	        return a.weight - b.weight;
	      }));
	    },
	    colorFormater: function colorFormater(colorField) {
	      (0, _keys2.default)(colorField.range).forEach(function (rangeKey) {
	        var range = colorField.range[rangeKey];
	
	        range.key = rangeKey;
	        switch (range.key) {
	          case 'GAM-39_tamisant-uni':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-39_tamisant-uni'];
	            range.priceindicator = '€';
	            range.picto = [];
	            range.weight = 1;
	            break;
	
	          case 'GAM-42_tamisant-effet-lin':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-42_tamisant-effet-lin'];
	            range.priceindicator = '€';
	            range.picto = [];
	            range.weight = 2;
	            break;
	
	          case 'GAM-43_tamisant-m1-uni':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-43_tamisant-m1-uni'];
	            range.priceindicator = '€';
	            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg'];
	            range.weight = 4;
	            break;
	
	          case 'GAM-44_m1-trvira-cs':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-44_m1-trvira-cs'];
	            range.priceindicator = '€€';
	            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg'];
	            range.weight = 5;
	            break;
	
	          case 'GAM-45_occultant-uni':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-45_occultant-uni'];
	            range.priceindicator = '€';
	            range.picto = [];
	            range.weight = 6;
	            break;
	
	          case 'GAM-46_occultant-m1-uni':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-46_occultant-m1-uni'];
	            range.priceindicator = '€€';
	            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg'];
	            range.weight = 7;
	            break;
	
	          case 'GAM-47_voile-graphique':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-47_voile-graphique'];
	            range.priceindicator = '€';
	            range.picto = [];
	            range.weight = 8;
	            break;
	
	          case 'GAM-48_anti-chaleur':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-48_anti-chaleur'];
	            range.priceindicator = '€€';
	            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-thermometre.jpg'];
	            range.weight = 9;
	            break;
	
	          case 'GAM-49_anti-chaleur-m1':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-49_anti-chaleur-m1'];
	            range.priceindicator = '€€';
	            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg', 'https://cdn.stores-discount.com/images/abtest/picto-thermometre.jpg'];
	            range.weight = 10;
	            break;
	
	          case 'GAM-51_bois-tiss':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-51_bois-tiss'];
	            range.priceindicator = '€€€';
	            range.picto = [];
	            range.weight = 11;
	            break;
	
	          case 'GAM-52_screen-uni':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-52_screen-uni'];
	            range.priceindicator = '€€€';
	            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg', 'https://cdn.stores-discount.com/images/abtest/picto-thermometre.jpg'];
	            range.weight = 52;
	            break;
	
	          case 'GAM-53_89-mm-tamisant-uni':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-53_89-mm-tamisant-uni'];
	            range.priceindicator = '€';
	            range.picto = [];
	            range.weight = 3;
	            break;
	
	          case 'GAM-54_89-mm-occultant-uni':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-54_89-mm-occultant-uni'];
	            range.priceindicator = '€';
	            range.picto = [];
	            range.weight = 12;
	            break;
	
	          case 'GAM-322_occultant-anti-chaleur-127mm':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-322_occultant-anti-chaleur-127mm'];
	            range.priceindicator = '€€€';
	            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg', 'https://cdn.stores-discount.com/images/abtest/picto-thermometre.jpg'];
	            range.weight = 16;
	            break;
	          case 'GAM-325_89mm-voile-haut-de-gamme':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-325_89mm-voile-haut-de-gamme'];
	            range.priceindicator = '€€';
	            range.picto = [];
	            range.weight = 17;
	            break;
	          case 'GAM-324_89mm-voile-effet-lin-treviras-cs':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-324_89mm-voile-effet-lin-treviras-cs'];
	            range.priceindicator = '€€€';
	            range.picto = ['https://cdn.stores-discount.com/images/abtest/picto-anti-feu.jpg'];
	            range.weight = 18;
	            break;
	          case 'GAM-326_127mm-tamisant-uni-tendance':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-326_127mm-tamisant-uni-tendance'];
	            range.priceindicator = '€';
	            range.picto = [];
	            range.weight = 3;
	            break;
	          case 'GAM-328_127mm-tamisant-haut-de-gamme':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-328_127mm-tamisant-haut-de-gamme'];
	            range.priceindicator = '€€';
	            range.picto = [];
	            range.weight = 5;
	            break;
	          case 'GAM-329_89mm-occultant-uni-tendance':
	            range.label = _translationFr2.default.abTest.prd14.variationB.fields.colorPicker.gamme['GAM-329_89mm-occultant-uni-tendance'];
	            range.priceindicator = '€';
	            range.picto = [];
	            range.weight = 15;
	            break;
	          default:
	            range.label = range.label;
	            range.priceindicator = '';
	            range.picto = [];
	            break;
	        }
	
	        colorField.range[rangeKey] = range;
	      });
	      colorField.range = this.sortObj(colorField.range);
	      return colorField;
	    },
	    filterUpdated: function filterUpdated(chOpt) {
	      this.$emit('field-changed', chOpt);
	    },
	    isVisible: function isVisible(colorKey, colorFormated) {
	      return !colorFormated.validation.hidden_values.find(function (code) {
	        return code === colorKey;
	      });
	    },
	    rangeIsNotEmpty: function rangeIsNotEmpty(color, range) {
	      return (0, _keys2.default)(this.colorByRangekey(color, range)).length > 0;
	    }
	  },
	  watch: {
	    cc: function cc(newValue, oldValue) {
	      if (newValue.config_1.prefilled_values['CH-142_type-de-store'] !== oldValue.config_1.prefilled_values['CH-142_type-de-store']) {
	        if (this.totalColorVariationSelected !== newValue.config_1.prefilled_values['CH-142_type-de-store']) {
	          this.totalColorVariationSelected = newValue.config_1.prefilled_values['CH-142_type-de-store'];
	        }
	      }
	    },
	    totalColorVariationSelected: function totalColorVariationSelected(newValue, oldValue) {
	      this.$emit('field-changed', (0, _defineProperty3.default)({}, this.totalColorVariation.chKey, { newValue: newValue }));
	      if (newValue === this.oneColorType) {
	        this.colorBSelected = '';
	        this.colorCSelected = '';
	      }
	      if (newValue === this.twoColorType && oldValue === this.threeColorType) {
	        this.colorCSelected = '';
	      }
	    },
	    colorASelected: function colorASelected(newValue, oldValue) {
	      this.colorASelectedSummary = this.colorisA.values[newValue];
	      this.colorBSelected = '';
	      this.colorCSelected = '';
	      this.$emit('field-changed', (0, _defineProperty3.default)({}, this.colorisA.chKey, { newValue: newValue }));
	    },
	    colorBSelected: function colorBSelected(newValue, oldValue) {
	      this.colorBSelectedSummary = this.colorisB.values[newValue];
	      this.colorCSelected = '';
	      this.$emit('field-changed', (0, _defineProperty3.default)({}, this.colorisB.chKey, { newValue: newValue }));
	    },
	    colorCSelected: function colorCSelected(newValue, oldValue) {
	      this.colorCSelectedSummary = this.colorisC.values[newValue];
	      this.$emit('field-changed', (0, _defineProperty3.default)({}, this.colorisC.chKey, { newValue: newValue }));
	    }
	  }
	};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _dimension = __webpack_require__(27);
	
	var _rendering_unit = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dimension',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', minValue: 0, maxValue: 100, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      val_uom: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _dimension.DimensionComputed),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _dimension.DimensionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _dimension.DimensionWatch)
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dimension = __webpack_require__(307);
	
	var _Dimension2 = _interopRequireDefault(_Dimension);
	
	var _translationFr = __webpack_require__(15);
	
	var _translationFr2 = _interopRequireDefault(_translationFr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dimensions-field-widget',
	  props: {
	    widthField: {
	      type: Object,
	      default: { label: 'width', minValue: 0, maxValue: 100, tooltip: '' }
	    },
	    heightField: {
	      type: Object,
	      default: { label: 'height', minValue: 0, maxValue: 100, tooltip: '' }
	    },
	    docLink: {
	      type: String,
	      default: ''
	    },
	    cc: {
	      type: Object,
	      default: function _default() {
	        return {
	          config_1: {
	            prefilled_values: {
	              widthFieldRef: 1000,
	              heightFieldRef: 1000
	            }
	          }
	        };
	      }
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    widthFieldRef: {
	      type: String,
	      default: ''
	    },
	    heightFieldRef: {
	      type: String,
	      default: ''
	    },
	    widthFieldLabel: {
	      type: String,
	      default: ''
	    },
	    widthFieldSubtitle: {
	      type: String,
	      default: ''
	    },
	    heightFieldLabel: {
	      type: String,
	      default: ''
	    },
	    heightFieldSubtitle: {
	      type: String,
	      default: ''
	    },
	    fieldHasChanged: {
	      type: Function,
	      default: function _default() {}
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {};
	  },
	  created: function created() {},
	  components: {
	    Dimension: _Dimension2.default
	  },
	  computed: {
	    frText: function frText() {
	      return _translationFr2.default;
	    },
	    getCcWidthValue: function getCcWidthValue() {
	      return this.cc.config_1.prefilled_values[this.widthFieldRef];
	    },
	    getCcHeightValue: function getCcHeightValue() {
	      return this.cc.config_1.prefilled_values[this.heightFieldRef];
	    },
	    hookedWidthField: function hookedWidthField() {
	      var field = this.widthField;
	      field.label = this.widthFieldLabel;
	      field.subtitle = this.widthFieldSubtitle;
	      return field;
	    },
	    hookedHeightField: function hookedHeightField() {
	      var field = this.heightField;
	      field.label = this.heightFieldLabel;
	      field.subtitle = this.heightFieldSubtitle;
	      return field;
	    }
	  },
	  methods: {},
	  watch: {
	    cc: function cc(newValue, oldValue) {}
	  }
	};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(56);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _translationFr = __webpack_require__(15);
	
	var _translationFr2 = _interopRequireDefault(_translationFr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'filter-field-widget',
	  props: {
	    field: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      filterSelectedValue: 'all',
	      taggedFilters: []
	    };
	  },
	  created: function created() {},
	  components: {},
	  computed: {
	    frText: function frText() {
	      return _translationFr2.default;
	    },
	    hookedFilterValues: function hookedFilterValues() {
	      return this.hookFilter(this.field).hookedValues;
	    }
	  },
	  methods: {
	    removeTag: function removeTag(tagValue) {
	      this.taggedFilters = this.taggedFilters.reduce(function (reduced, tag) {
	        if (tag.value !== tagValue) {
	          reduced.push(tag);
	        }
	        return reduced;
	      }, []);
	    },
	    hookFilter: function hookFilter(field) {
	      field.hookedValues = {
	        all: {
	          label: 'FILTRER PAR COULEURS',
	          value: 'all',
	          relatedFilterValues: ['VALFIL-37_blanc', 'VALFIL-38_beige', 'VALFIL-39_marron', 'VALFIL-40_noir', 'VALFIL-41_gris', 'VALFIL-43_rouge', 'VALFIL-44_rose-violet', 'VALFIL-46_jaune', 'VALFIL-45_orange', 'VALFIL-42_bleu', 'VALFIL-61_vert']
	        },
	        white: {
	          label: 'Blanc',
	          value: 'white',
	          relatedFilterValues: ['VALFIL-37_blanc']
	        },
	        beigeBrown: {
	          label: 'Beige - Marron',
	          value: 'beigeBrown',
	          relatedFilterValues: ['VALFIL-38_beige', 'VALFIL-39_marron']
	        },
	        greyBlack: {
	          label: 'Gris - Noir',
	          value: 'greyBlack',
	          relatedFilterValues: ['VALFIL-40_noir', 'VALFIL-41_gris']
	        },
	        redPinkPurple: {
	          label: 'Rouge - Rose - Violet',
	          value: 'redPinkPurple',
	          relatedFilterValues: ['VALFIL-43_rouge', 'VALFIL-44_rose-violet']
	        },
	        yellowOrange: {
	          label: 'Jaune / Orange',
	          value: 'yellowOrange',
	          relatedFilterValues: ['VALFIL-46_jaune', 'VALFIL-45_orange']
	        },
	        blueGreen: {
	          label: 'Bleu / Vert',
	          value: 'blueGreen',
	          relatedFilterValues: ['VALFIL-42_bleu', 'VALFIL-61_vert']
	        }
	      };
	      return field;
	    }
	  },
	  watch: {
	    filterSelectedValue: function filterSelectedValue(newValue, oldValue) {
	      if (this.taggedFilters.length === 0) {
	        if (newValue !== 'all') {
	          this.taggedFilters.push(this.hookFilter(this.field).hookedValues[newValue]);
	        }
	      } else if (!this.taggedFilters.find(function (filterValue) {
	        return filterValue.value === newValue || newValue === 'all';
	      })) {
	        this.taggedFilters.push(this.hookFilter(this.field).hookedValues[newValue]);
	      }
	    },
	    taggedFilters: function taggedFilters(newValue, oldValue) {
	      var filtersValue = newValue.reduce(function (reduced, tag) {
	        reduced = [].concat((0, _toConsumableArray3.default)(reduced), (0, _toConsumableArray3.default)(tag.relatedFilterValues));
	        return reduced;
	      }, []);
	      if (filtersValue.length === 0) {
	        filtersValue = this.hookFilter(this.field).hookedValues.all.relatedFilterValues;
	      }
	      this.$emit('change-color-filter-values', (0, _defineProperty3.default)({}, this.field.chKey, {
	        newValue: filtersValue
	      }));
	    }
	  }
	};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _translationFr = __webpack_require__(15);
	
	var _translationFr2 = _interopRequireDefault(_translationFr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'rail-field-widget',
	  props: {
	    cc: {
	      type: Object,
	      default: function _default() {
	        return {
	          config_1: {
	            prefilled_values: {
	              'CH-147_couleur-de-rail-classique': 'OPT-236_blanc-ral-9010'
	            }
	          }
	        };
	      }
	    },
	    railTypeField: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    railColorField: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    return {
	      selected: null
	    };
	  },
	  created: function created() {
	    if (this.cc['CH-147_couleur-de-rail-classique'] != null) {
	      this.selected = this.cc['CH-147_couleur-de-rail-classique'];
	    }
	  },
	  computed: {
	    frText: function frText() {
	      return _translationFr2.default;
	    }
	  },
	  methods: {
	    getRelatedRailTypeOptKey: function getRelatedRailTypeOptKey(railColorOptKey) {
	      var adaptedRailType = this.adaptedRailTypes();
	      return adaptedRailType.reduce(function (reduced, rail) {
	        var relatedColor = rail.relatedColorOpt.find(function (colorOpt) {
	          return colorOpt.value === railColorOptKey;
	        });
	        if (relatedColor) {
	          reduced = rail.key;
	        }
	        return reduced;
	      }, 'OPT-234_rail-classique');
	    },
	    adaptedRailTypes: function adaptedRailTypes() {
	      var _this = this;
	
	      var getColorLabel = function getColorLabel() {
	        if (_this.railColorField.values) {
	          if (_this.railColorField.values[_this.selected]) {
	            return _this.railColorField.values[_this.selected].label;
	          }
	        }
	        return false;
	      };
	
	      var colorSelectedIsClassic = false;
	      var classicRailColor = [];
	      if (this.railColorField.values['OPT-236_blanc-ral-9010']) {
	        classicRailColor.push((0, _assign2.default)({}, this.railColorField.values['OPT-236_blanc-ral-9010'], {
	          colorOptKey: 'OPT-236_blanc-ral-9010',
	          pictureColor: '#FFFFFF',
	          pictureBorderColor: '#909090'
	        }));
	        colorSelectedIsClassic = colorSelectedIsClassic || this.selected === 'OPT-236_blanc-ral-9010';
	      }
	      if (this.railColorField.values['OPT-270_marron-ral-8014']) {
	        classicRailColor.push((0, _assign2.default)({}, this.railColorField.values['OPT-270_marron-ral-8014'], {
	          colorOptKey: 'OPT-270_marron-ral-8014',
	          pictureColor: '#543c2b',
	          pictureBorderColor: '#543c2b'
	        }));
	        colorSelectedIsClassic = colorSelectedIsClassic || this.selected === 'OPT-270_marron-ral-8014';
	      }
	
	      var premiumRailColor = [];
	      if (this.railColorField.values['OPT-238_blanc-ral-9016']) {
	        premiumRailColor.push((0, _assign2.default)({}, this.railColorField.values['OPT-238_blanc-ral-9016'], {
	          colorOptKey: 'OPT-238_blanc-ral-9016',
	          pictureColor: '#FFFFFF',
	          pictureBorderColor: '#909090'
	        }));
	      }
	      if (this.railColorField.values['OPT-240_marron-ral-8077']) {
	        premiumRailColor.push((0, _assign2.default)({}, this.railColorField.values['OPT-240_marron-ral-8077'], {
	          colorOptKey: 'OPT-240_marron-ral-8077',
	          pictureColor: '#543c2b',
	          pictureBorderColor: '#543c2b'
	        }));
	      }
	      if (this.railColorField.values['OPT-242_noir-ral-9005']) {
	        premiumRailColor.push((0, _assign2.default)({}, this.railColorField.values['OPT-242_noir-ral-9005'], {
	          colorOptKey: 'OPT-242_noir-ral-9005',
	          pictureColor: '#000000',
	          pictureBorderColor: '#000000'
	        }));
	      }
	
	      var adaptedValues = (0, _keys2.default)(this.railTypeField.values).reduce(function (reduced, railTypeKey) {
	        var railTypeOpt = _this.railTypeField.values[railTypeKey];
	        reduced.push({
	          key: railTypeKey,
	          colorSumary: !colorSelectedIsClassic && railTypeKey !== 'OPT-234_rail-classique' || colorSelectedIsClassic && railTypeKey === 'OPT-234_rail-classique' ? getColorLabel() : null,
	          opt: railTypeOpt,
	          subTitle: railTypeKey === 'OPT-234_rail-classique' ? null : '(utilisation intensive)',
	          priceIndicator: railTypeKey === 'OPT-234_rail-classique' ? '€' : '€€',
	          relatedColorOpt: railTypeKey === 'OPT-234_rail-classique' ? classicRailColor : premiumRailColor
	        });
	        return reduced;
	      }, []);
	      return adaptedValues;
	    }
	  },
	  watch: {
	    selected: function selected(newValue, oldValue) {
	      var _$emit;
	
	      var relatedRailTypeOptKey = this.getRelatedRailTypeOptKey(newValue);
	      this.$emit('change-rail-color-type', (_$emit = {}, (0, _defineProperty3.default)(_$emit, this.railTypeField.chKey, relatedRailTypeOptKey), (0, _defineProperty3.default)(_$emit, this.railColorField.chKey, newValue), _$emit));
	    },
	    cc: function cc(newValue, oldValue) {
	      if (typeof newValue.config_1.prefilled_values['CH-147_couleur-de-rail-classique'] !== 'undefined') {
	        if (newValue.config_1.prefilled_values['CH-147_couleur-de-rail-classique'] !== this.selected) {
	          this.selected = newValue.config_1.prefilled_values['CH-147_couleur-de-rail-classique'];
	        }
	      }
	    }
	  }
	};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-246_repli-gauche':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/replis_gauche.jpg';
	            break;
	          case 'OPT-247_repli-droite':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/replis_droite.jpg';
	            break;
	          case 'OPT-248_repli-des-2-cts':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/replis_centre.jpg';
	            break;
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-223_127-mm':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/bandes_127mm.jpg';
	            break;
	          case 'OPT-224_89-mm':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/bandes_89mm.jpg';
	            break;
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-2390_fixations-plafond':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fixation_plafond.jpg?v=1';
	            break;
	          case 'OPT-2391_equerres':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fixation_murale.jpg?v=1';
	            break;
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-274_gauche':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/commande_gauche.jpg?v=1';
	            break;
	          case 'OPT-273_droite':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/commande_droite.jpg?v=1';
	            break;
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-1199_pan-coup':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/coffre_pan-coupe.png';
	            break;
	          case 'OPT-1209_1-4-de-rond':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/coffre_quart-rond.png';
	            break;
	          case 'OPT-1210_1-2-rond':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/coffre_demi-rond.png';
	            break;
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    },
	    cc: {
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-1219_sangle':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_sangle.png';
	            break;
	          case 'OPT-1220_treuil':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_treuil.png';
	            break;
	          case 'OPT-1221_tirage-direct-avec-verrou':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_tirage-direct.png';
	            break;
	          case 'OPT-1222_moteur-standard-filaire':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok.png';
	            break;
	          case 'OPT-1223_moteur-somfy-filaire':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy.png';
	            break;
	          case 'OPT-1224_moteur-standard-tlcommand':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok.png';
	            break;
	          case 'OPT-1225_moteur-somfy-tlcommand':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy.png';
	            break;
	          case 'OPT-1328_moteur-somfy-telecommande-io':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy-io.png';
	            break;
	          case 'OPT-1431_moteur-standard-solaire':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok.png';
	            break;
	          case 'OPT-1434_moteur-somfy-solaire':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy.png';
	            break;
	
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods, {
	    getLabel: function getLabel() {
	      return this.checkCmdFilter() ? 'Type de commande' : 'Moteur';
	    },
	
	    checkCmdFilter: function checkCmdFilter() {
	      return this.cc.config_1.prefilled_values['CH-616_filtre-commande'] === 'OPT-2424_manuel' || this.cc.config_1.prefilled_values['CH-622_filtre-commande'] === 'OPT-2437_manuel';
	    }
	  }),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    },
	    cc: {
	      type: Object,
	      default: null
	    },
	    validation: {
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      var radioCheck = this.checkCmdFilter();
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-1193_gauche':
	            fieldValues[valueRef]['label'] = radioCheck ? 'À gauche' : fieldValues[valueRef]['label'];
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/sans.png';
	            break;
	          case 'OPT-1194_droite':
	            fieldValues[valueRef]['label'] = radioCheck ? 'À droite' : fieldValues[valueRef]['label'];
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_interrupteur.png';
	            break;
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods, {
	    getLabel: function getLabel(field) {
	      return this.checkCmdFilter() ? 'Sortie électrique (vue de l\'intérieur)' : field.label;
	    },
	
	    checkCmdFilter: function checkCmdFilter() {
	      return this.cc.config_1.prefilled_values['CH-616_filtre-commande'] === 'OPT-2426_motorise-radio-commande' || this.cc.config_1.prefilled_values['CH-622_filtre-commande'] === 'OPT-2439_motorise-radio-commande';
	    }
	  }),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-1195_a-sous-linteau-coffre-vers-lextrieur':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/pose_sous-linteau.png';
	            break;
	          case 'OPT-1196_b-sous-linteau-invers-coffre-vers-lintrie':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/pose_sous-linteau-inv.png';
	            break;
	          case 'OPT-1197_c-en-applique-contre-faade':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/pose_contre-facade.png';
	            break;
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    },
	    cc: {
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-1239_sans-commande':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/sans.png';
	            break;
	          case 'OPT-1229_interrupteur':
	            fieldValues[valueRef]['picture'] = me.cc.config_1.prefilled_values['CH-469_commande'] === 'OPT-1222_moteur-standard-filaire' ? 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_interrupteur.png' : 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_interrupteur_bis.png';
	            break;
	          case 'OPT-1230_interrupteur-inverseur-extrieur-cl':
	            fieldValues[valueRef]['picture'] = me.cc.config_1.prefilled_values['CH-469_commande'] === 'OPT-1222_moteur-standard-filaire' ? 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_interrupteur-inv-ext.png' : 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_interrupteur-inv-ext-bis.png';
	            break;
	          case 'OPT-1231_inverseur-extrieur-cl':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_inverseur-ext.png';
	            break;
	          case 'OPT-2428_telecommande-1-canal-standard':
	          case 'OPT-2441_telecommande-1-canal-standard':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok-1-canal.png';
	            break;
	          case 'OPT-1226_tlcommande-1-canal':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy-1-canal.png';
	            break;
	          case 'OPT-1227_tlcommande-multi-canaux':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy-5-canaux.png';
	            break;
	          case 'OPT-1435_telecommande-6-canaux':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok-6-canaux.png';
	            break;
	          case 'OPT-2429_telecommande-16-canaux-standard':
	          case 'OPT-2442_telecommande-16-canaux-standard':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_aok-16-canaux.png';
	            break;
	          case 'OPT-1228_tlcommande-multi-canaux-plus':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy-16-canaux.png';
	            break;
	          case 'OPT-1330_telecommande-io':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy-io-telecommande-1-canal.png';
	            break;
	          case 'OPT-1238_tlcommande-smoove':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy-telecommande-murale-1-canal.png';
	            break;
	          case 'OPT-1401_tlcommande-smoove-io':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/commande_somfy-io-telecommande-murale-1-canal.png';
	            break;
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods, {
	    getGrid: function getGrid() {
	      var visibleItems = Math.abs(this.field.validation.hidden_values.length - (0, _keys2.default)(this.field.values).length);
	      return visibleItems > 4 ? 'flex-6-cols' : 'flex-5-cols';
	    }
	  }),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(2);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _global = __webpack_require__(1);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _selection = __webpack_require__(7);
	
	var _rendering_unit = __webpack_require__(3);
	
	var _common = __webpack_require__(4);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'selection-info-label',
	  props: {
	    fieldRef: {
	      type: String,
	      default: ''
	    },
	    productReference: {
	      type: String,
	      default: null
	    },
	    version: {
	      type: String,
	      default: 'default'
	    },
	    field: {
	      type: Object,
	      default: { label: '', values: {}, tooltip: '' }
	    },
	    cc_value: {
	      type: [Number, String],
	      default: 0
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    mint: {
	      type: Number,
	      default: 0
	    },
	    cc: {
	      type: Object,
	      default: null
	    }
	  },
	  data: function data() {
	    return {
	      selected: this.cc_value
	    };
	  },
	
	  components: _global2.default.components,
	  computed: (0, _assign2.default)({}, _rendering_unit.RenderingUnitComputed, _selection.SelectionComputed, {
	    injectPictureInOption: function injectPictureInOption() {
	      var me = this;
	      var fieldValues = _common2.default.cloneDataObject(this.field.values);
	      (0, _keys2.default)(fieldValues).map(function (valueRef) {
	        fieldValues[valueRef]['display'] = me.isOptionVisible(valueRef);
	        fieldValues[valueRef]['disabled'] = me.isOptionDisable(valueRef);
	        switch (valueRef) {
	          case 'OPT-1234_sans':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/sans.png';
	            break;
	          case 'OPT-1235_verrou':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/optsecu_verrou-bas.png';
	            break;
	          case 'OPT-1240_verrou-au-milieu':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/optsecu_verrou-bas.png';
	            break;
	          case 'OPT-1241_attache-scurit':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/optsecu-attache-secu.png';
	            break;
	          case 'OPT-1242_verrou-bas-attache-scurit':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/optsecu_verrou-bas-attache.png';
	            break;
	          case 'OPT-1289_verrou-au-milieu-attache-scurit':
	            fieldValues[valueRef]['picture'] = 'https://cdn.stores-discount.com/images/abtest/fp-volet-roulant-reno/configurateur/optsecu_verrou-bas-attache.png';
	            break;
	
	          default:
	            fieldValues[valueRef]['picture'] = '';
	            break;
	        }
	      });
	      return fieldValues;
	    }
	  }),
	  methods: (0, _assign2.default)({}, _rendering_unit.RenderingUnitMethods, _selection.SelectionMethods, {
	    getValue: function getValue() {
	      return this.cc.config_1.prefilled_values['CH-469_commande'] === 'OPT-1221_tirage-direct-avec-verrou' ? 'OPT-1235_verrou' : this.cc_value;
	    }
	  }),
	  watch: (0, _assign2.default)({}, _rendering_unit.RenderingUnitWatch, _selection.SelectionWatch)
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(22);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _slicedToArray2 = __webpack_require__(55);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _entries = __webpack_require__(54);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _keys = __webpack_require__(5);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _translationFr = __webpack_require__(15);
	
	var _translationFr2 = _interopRequireDefault(_translationFr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'vr-color-picker-field-widget',
	  props: {
	
	    colorisA: {
	      type: Object,
	      default: {}
	    },
	    cc: {
	      type: Object,
	      default: function _default() {
	        return {
	          config_1: {
	            prefilled_values: {
	              'CH-458_matire': 'OPT-1184_aluminium'
	            }
	          }
	        };
	      }
	    },
	    validation: {
	      type: Object,
	      default: {}
	    },
	    uom: {
	      type: String,
	      default: 'cm'
	    },
	    fieldHasChanged: {
	      type: Function,
	      default: function _default() {}
	    },
	    mint: {
	      type: Number,
	      default: 0
	    }
	  },
	  data: function data() {
	    return {
	      colorASelected: null,
	      oneColorType: '',
	      selectedColor: '',
	      colorASelectedSummary: {
	        range: '',
	        label: '',
	        key: ''
	      }
	    };
	  },
	  created: function created() {
	    this.colorASelected = this.cc.config_1.prefilled_values['CH-461_coloris'];
	  },
	  updated: function updated() {
	    this.colorASelected = this.cc.config_1.prefilled_values['CH-461_coloris'];
	  },
	  components: {},
	  computed: {
	    frText: function frText() {
	      return _translationFr2.default;
	    },
	    colorAFormated: function colorAFormated() {
	      return this.colorisA;
	    },
	    isOneColorType: function isOneColorType() {
	      return this.cc.config_1.prefilled_values['CH-461_coloris'] === this.oneColorType;
	    }
	  },
	  methods: {
	    isThisRange: function isThisRange(colorKey, rangeKey) {
	      return colorKey.includes(rangeKey);
	    },
	    colorPictureStyleBackground: function colorPictureStyleBackground(url) {
	      var outOfStock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var imgOutOfStock = outOfStock ? "url('https://cdn.configurateur.stores-discount.com/matiere/rupture-neutre.png') no-repeat -1px," : '';
	      return imgOutOfStock + ' url(' + url + ') no-repeat -3px -3px';
	    },
	    colorByRangekey: function colorByRangekey(colorFormated, rangeKey) {
	      var _this = this;
	
	      return (0, _keys2.default)(colorFormated.values).reduce(function (reduced, colorKey) {
	        var color = colorFormated.values[colorKey];
	        if (colorKey.includes(rangeKey)) {
	          var hidenValues = (colorFormated.validation || {}).hidden_values || [];
	          if (!hidenValues.find(function (hiddenRangeKey) {
	            return hiddenRangeKey === colorKey;
	          })) {
	            if (_this.isVisible(colorKey, colorFormated)) {
	              reduced[colorKey] = color;
	            }
	          }
	        }
	        return reduced;
	      }, {});
	    },
	    sortObj: function sortObj(obj) {
	      return Object.fromEntries((0, _entries2.default)(obj).sort(function (_ref, _ref2) {
	        var _ref4 = (0, _slicedToArray3.default)(_ref, 2),
	            a = _ref4[1];
	
	        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
	            b = _ref3[1];
	
	        return a.weight - b.weight;
	      }));
	    },
	    filterUpdated: function filterUpdated(chOpt) {
	      this.$emit('field-changed', chOpt);
	    },
	    isVisible: function isVisible(colorKey, colorFormated) {
	      var hidenValues = (colorFormated.validation || {}).hidden_values || [];
	      return !hidenValues.find(function (code) {
	        return code === colorKey;
	      });
	    },
	    rangeIsNotEmpty: function rangeIsNotEmpty(color, range) {
	      return (0, _keys2.default)(this.colorByRangekey(color, range)).length > 0;
	    },
	    getRanges: function getRanges() {
	      var hiddenValues = this.validation.hidden_values || [];
	      var ranges = [{
	        label: 'Aluminium',
	        key: 'alu'
	      }];
	      if (hiddenValues.includes('CH-461_coloris_MAT-510_vr-pvc-blanc') && hiddenValues.includes('CH-461_coloris_MAT-1560_vr-pvc-beige')) {
	        return ranges;
	      } else {
	        ranges.push({
	          label: 'PVC',
	          key: 'pvc'
	        });
	      }
	      return ranges;
	    },
	    getSummary: function getSummary() {
	      var ral = this.colorASelectedSummary.ral !== 'N/A' ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;RAL ' + this.colorASelectedSummary.ral : '';
	      return this.colorASelectedSummary.label + ' ' + ral;
	    }
	  },
	  watch: {
	    cc: function cc(newValue, oldValue) {},
	    colorASelected: function colorASelected(newValue, oldValue) {
	      this.colorASelectedSummary = this.colorisA.values[newValue];
	      this.selectedColor = newValue;
	      var materialValue = newValue === 'CH-461_coloris_MAT-510_vr-pvc-blanc' || newValue === 'CH-461_coloris_MAT-1560_vr-pvc-beige' ? 'OPT-1185_pvc' : 'OPT-1184_aluminium';
	      this.$emit('field-changed', (0, _defineProperty3.default)({}, this.colorisA.chKey, { newValue: newValue }));
	
	      this.$emit('field-changed', {
	        'CH-458_matire': { newValue: materialValue }
	      });
	    }
	  }
	};

/***/ }),
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 204 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 205 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 213 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 241 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 243 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = {"rendering_components":{"LabelComponent":"LabelComponent","TextComponent":"TextComponent","RangeComponent":"RangeMinMaxComponent","InputNumberComponent":"InputNumberComponent","InputTextComponent":"InputTextComponent","Modal":"ModalWithButton","Tooltip":"TooltipWithImage","CheckboxList":"CheckboxListWithAllOption","ImageComponent":"ImageComponent","SelectComponent":"SelectComponent","SelectWithPictureComponent":"SelectWithPictureComponent","ImageRadioList":"ImageRadioList","ImageRadioListWithTooltip":"ImageRadioListWithTooltip","GalleryZoom":"ZoomSeparated","ZoomInPlace":"ZoomInPlace","GalleryModal":"GalleryModal","SelectWithTextComponent":"SelectWithTextComponent"},"rendering_blocks":{"GalleryBlock":"GalleryBlock","VirtualForm":"VirtualForm"},"rendering_units":{"RailFieldWidget":"RailFieldWidget","DimensionsFieldWidget":"DimensionsFieldWidget","FilterFieldWidget":"FilterFieldWidget","ColorPickerFieldWidget":"ColorPickerFieldWidget","Dimension":"Dimension","DimensionMobile":"DimensionMobile","Selection":"Selection","SelectionMobile":"SelectionMobile","Material":"Material","Unit":"Unit","UnitMobile":"UnitMobile","MaterialMobile":"MaterialMobile","Gallery":"GalleryWithModal","VrColorPickerFieldWidget":"VrColorPickerFieldWidget"},"mapping":[{"name":"option","rendering_unit":"Selection","rendering_unit_mobile":"SelectionMobile"},{"name":"unit","rendering_unit":"Unit","rendering_unit_mobile":"UnitMobile"},{"name":"size","rendering_unit":"Dimension","rendering_unit_mobile":"DimensionMobile"},{"name":"filter","rendering_unit":"Selection","rendering_unit_mobile":"SelectionMobile"},{"name":"material","rendering_unit":"Material","rendering_unit_mobile":"MaterialMobile"}]}

/***/ }),
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(246)
	
	/* script */
	__vue_exports__ = __webpack_require__(84)
	
	/* template */
	var __vue_template__ = __webpack_require__(367)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-9aa35bfe"
	
	module.exports = __vue_exports__


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(226)
	
	/* script */
	__vue_exports__ = __webpack_require__(85)
	
	/* template */
	var __vue_template__ = __webpack_require__(347)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-42007d7e"
	
	module.exports = __vue_exports__


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(229)
	
	/* script */
	__vue_exports__ = __webpack_require__(86)
	
	/* template */
	var __vue_template__ = __webpack_require__(350)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-47528894"
	
	module.exports = __vue_exports__


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(242)
	
	/* script */
	__vue_exports__ = __webpack_require__(87)
	
	/* template */
	var __vue_template__ = __webpack_require__(363)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-78d1d1d9"
	
	module.exports = __vue_exports__


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(202)
	
	/* script */
	__vue_exports__ = __webpack_require__(88)
	
	/* template */
	var __vue_template__ = __webpack_require__(323)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-09bf9930"
	
	module.exports = __vue_exports__


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(203)
	
	/* script */
	__vue_exports__ = __webpack_require__(89)
	
	/* template */
	var __vue_template__ = __webpack_require__(324)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0e7e69e8"
	
	module.exports = __vue_exports__


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(234)
	
	/* script */
	__vue_exports__ = __webpack_require__(90)
	
	/* template */
	var __vue_template__ = __webpack_require__(355)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5f9b78b0"
	
	module.exports = __vue_exports__


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(236)
	
	/* script */
	__vue_exports__ = __webpack_require__(91)
	
	/* template */
	var __vue_template__ = __webpack_require__(357)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-621932c5"
	
	module.exports = __vue_exports__


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(253)
	
	/* script */
	__vue_exports__ = __webpack_require__(92)
	
	/* template */
	var __vue_template__ = __webpack_require__(374)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-f286be40"
	
	module.exports = __vue_exports__


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(249)
	
	/* script */
	__vue_exports__ = __webpack_require__(93)
	
	/* template */
	var __vue_template__ = __webpack_require__(370)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cf5d95e6"
	
	module.exports = __vue_exports__


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(225)
	
	/* script */
	__vue_exports__ = __webpack_require__(94)
	
	/* template */
	var __vue_template__ = __webpack_require__(346)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3fa1058f"
	
	module.exports = __vue_exports__


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(207)
	
	/* script */
	__vue_exports__ = __webpack_require__(95)
	
	/* template */
	var __vue_template__ = __webpack_require__(328)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-133cfc3a"
	
	module.exports = __vue_exports__


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(214)
	
	/* script */
	__vue_exports__ = __webpack_require__(96)
	
	/* template */
	var __vue_template__ = __webpack_require__(335)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-20b6db3c"
	
	module.exports = __vue_exports__


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(233)
	
	/* script */
	__vue_exports__ = __webpack_require__(97)
	
	/* template */
	var __vue_template__ = __webpack_require__(354)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5be9c974"
	
	module.exports = __vue_exports__


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(245)
	
	/* script */
	__vue_exports__ = __webpack_require__(98)
	
	/* template */
	var __vue_template__ = __webpack_require__(366)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8275a4f4"
	
	module.exports = __vue_exports__


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(240)
	
	/* script */
	__vue_exports__ = __webpack_require__(99)
	
	/* template */
	var __vue_template__ = __webpack_require__(361)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-73ad31dd"
	
	module.exports = __vue_exports__


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(220)
	
	/* script */
	__vue_exports__ = __webpack_require__(100)
	
	/* template */
	var __vue_template__ = __webpack_require__(341)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2c76216a"
	
	module.exports = __vue_exports__


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(239)
	
	/* script */
	__vue_exports__ = __webpack_require__(101)
	
	/* template */
	var __vue_template__ = __webpack_require__(360)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-73a38943"
	
	module.exports = __vue_exports__


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(241)
	
	/* script */
	__vue_exports__ = __webpack_require__(102)
	
	/* template */
	var __vue_template__ = __webpack_require__(362)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-74b36175"
	
	module.exports = __vue_exports__


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(215)
	
	/* script */
	__vue_exports__ = __webpack_require__(103)
	
	/* template */
	var __vue_template__ = __webpack_require__(336)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(209)
	
	/* script */
	__vue_exports__ = __webpack_require__(104)
	
	/* template */
	var __vue_template__ = __webpack_require__(330)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-151199df"
	
	module.exports = __vue_exports__


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(243)
	
	/* script */
	__vue_exports__ = __webpack_require__(105)
	
	/* template */
	var __vue_template__ = __webpack_require__(364)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-81381844"
	
	module.exports = __vue_exports__


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(223)
	
	/* script */
	__vue_exports__ = __webpack_require__(106)
	
	/* template */
	var __vue_template__ = __webpack_require__(344)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-333d8af6"
	
	module.exports = __vue_exports__


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(227)
	
	/* script */
	__vue_exports__ = __webpack_require__(107)
	
	/* template */
	var __vue_template__ = __webpack_require__(348)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-42a10e35"
	
	module.exports = __vue_exports__


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(231)
	
	/* script */
	__vue_exports__ = __webpack_require__(108)
	
	/* template */
	var __vue_template__ = __webpack_require__(352)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4e9c8c66"
	
	module.exports = __vue_exports__


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(238)
	
	/* script */
	__vue_exports__ = __webpack_require__(109)
	
	/* template */
	var __vue_template__ = __webpack_require__(359)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(205)
	
	/* script */
	__vue_exports__ = __webpack_require__(110)
	
	/* template */
	var __vue_template__ = __webpack_require__(326)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(201)
	
	/* script */
	__vue_exports__ = __webpack_require__(111)
	
	/* template */
	var __vue_template__ = __webpack_require__(322)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(250)
	
	/* script */
	__vue_exports__ = __webpack_require__(112)
	
	/* template */
	var __vue_template__ = __webpack_require__(371)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-dedba722"
	
	module.exports = __vue_exports__


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(251)
	
	/* script */
	__vue_exports__ = __webpack_require__(113)
	
	/* template */
	var __vue_template__ = __webpack_require__(372)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-e2c956f0"
	
	module.exports = __vue_exports__


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(252)
	
	/* script */
	__vue_exports__ = __webpack_require__(114)
	
	/* template */
	var __vue_template__ = __webpack_require__(373)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(200)
	
	/* script */
	__vue_exports__ = __webpack_require__(115)
	
	/* template */
	var __vue_template__ = __webpack_require__(321)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(211)
	
	/* script */
	__vue_exports__ = __webpack_require__(117)
	
	/* template */
	var __vue_template__ = __webpack_require__(332)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(244)
	
	/* script */
	__vue_exports__ = __webpack_require__(118)
	
	/* template */
	var __vue_template__ = __webpack_require__(365)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(217)
	
	/* script */
	__vue_exports__ = __webpack_require__(119)
	
	/* template */
	var __vue_template__ = __webpack_require__(338)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(204)
	
	/* script */
	__vue_exports__ = __webpack_require__(120)
	
	/* template */
	var __vue_template__ = __webpack_require__(325)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(216)
	
	/* script */
	__vue_exports__ = __webpack_require__(121)
	
	/* template */
	var __vue_template__ = __webpack_require__(337)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(206)
	
	/* script */
	__vue_exports__ = __webpack_require__(122)
	
	/* template */
	var __vue_template__ = __webpack_require__(327)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-116066a6"
	
	module.exports = __vue_exports__


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(224)
	
	/* script */
	__vue_exports__ = __webpack_require__(123)
	
	/* template */
	var __vue_template__ = __webpack_require__(345)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(237)
	
	/* script */
	__vue_exports__ = __webpack_require__(124)
	
	/* template */
	var __vue_template__ = __webpack_require__(358)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-62664e88"
	
	module.exports = __vue_exports__


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(248)
	
	/* script */
	__vue_exports__ = __webpack_require__(126)
	
	/* template */
	var __vue_template__ = __webpack_require__(369)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(235)
	
	/* script */
	__vue_exports__ = __webpack_require__(127)
	
	/* template */
	var __vue_template__ = __webpack_require__(356)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(213)
	
	/* script */
	__vue_exports__ = __webpack_require__(128)
	
	/* template */
	var __vue_template__ = __webpack_require__(334)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(210)
	
	/* script */
	__vue_exports__ = __webpack_require__(129)
	
	/* template */
	var __vue_template__ = __webpack_require__(331)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(208)
	
	/* script */
	__vue_exports__ = __webpack_require__(130)
	
	/* template */
	var __vue_template__ = __webpack_require__(329)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(221)
	
	/* script */
	__vue_exports__ = __webpack_require__(131)
	
	/* template */
	var __vue_template__ = __webpack_require__(342)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(247)
	
	/* script */
	__vue_exports__ = __webpack_require__(132)
	
	/* template */
	var __vue_template__ = __webpack_require__(368)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(228)
	
	/* script */
	__vue_exports__ = __webpack_require__(133)
	
	/* template */
	var __vue_template__ = __webpack_require__(349)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(230)
	
	/* script */
	__vue_exports__ = __webpack_require__(134)
	
	/* template */
	var __vue_template__ = __webpack_require__(351)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(222)
	
	/* script */
	__vue_exports__ = __webpack_require__(135)
	
	/* template */
	var __vue_template__ = __webpack_require__(343)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(232)
	
	/* script */
	__vue_exports__ = __webpack_require__(136)
	
	/* template */
	var __vue_template__ = __webpack_require__(353)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(218)
	
	/* script */
	__vue_exports__ = __webpack_require__(137)
	
	/* template */
	var __vue_template__ = __webpack_require__(339)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-284ae12e"
	
	module.exports = __vue_exports__


/***/ }),
/* 321 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-material mobile-display"
	  }, [_c('div', [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "olst-material-color-label",
	    domProps: {
	      "innerHTML": _vm._s(_vm.imageLabel)
	    }
	  })], 1), (_vm.filters && _vm.filters.length) ? _c('div', {
	    staticClass: "olst-material-checkbox"
	  }, [_vm._l((_vm.filters), function(filter) {
	    return _c('div', {
	      staticClass: "olst-field-checkbox olst-field-multi-checkbox olst-field-checkbox",
	      class: {
	        'olst-field-unique-checkbox': !_vm.hasMultiCheckbox(), 'olst-field-checkbox-big': _vm.isBigCheckboxList(filter.key), 'olst-field-checkbox-small': !_vm.isBigCheckboxList(filter.key)
	      }
	    }, [_c('checkbox-list', {
	      attrs: {
	        "name": filter.key,
	        "filter": filter.value,
	        "withAll": true,
	        "hideFilters": filter.closed
	      },
	      on: {
	        "value-changed": _vm.filterChanged,
	        "label-clicked": _vm.toggleFilter
	      }
	    })], 1)
	  }), _c('div', {
	    staticClass: "olst-clear"
	  })], 2) : _vm._e(), _c('div', [_c('div', {
	    staticClass: "olst-color-picker"
	  }, [_c('image-radio-list', {
	    attrs: {
	      "options": _vm.field.values,
	      "name": _vm.fieldRef,
	      "tooltip_options": _vm.field.range,
	      "hiddenValues": _vm.hiddenValue,
	      "disabledValues": _vm.disabledValue,
	      "defaultField": _vm.field.defaultVal
	    },
	    on: {
	      "image-label-changed": _vm.imageLabelChanged,
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1)])]), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-dimension"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('range-component', {
	    attrs: {
	      "min": _vm.minUomized,
	      "max": _vm.maxUomized,
	      "uom": _vm.uom
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e(), _c('br'), _c('input-number-component', {
	    class: {
	      'validation-field-error': _vm.hasError, 'validation-field-warning': _vm.hasWarning, 'validation-field-info': _vm.hasInfo
	    },
	    attrs: {
	      "name": _vm.fieldRef,
	      "defaultValue": _vm.cc_value,
	      "min": _vm.minUomized,
	      "max": _vm.maxUomized,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.valueChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected),
	      expression: "selected"
	    }],
	    attrs: {
	      "id": _vm.name,
	      "type": "checkbox"
	    },
	    domProps: {
	      "value": _vm.value,
	      "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, _vm.value) > -1 : (_vm.selected)
	    },
	    on: {
	      "change": [function($event) {
	        var $$a = _vm.selected,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = _vm.value,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.selected = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.selected = $$c
	        }
	      }, function($event) {
	        _vm.change(_vm.name)
	      }]
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    attrs: {
	      "type": "number",
	      "id": _vm.name,
	      "name": _vm.name,
	      "min": _vm.minimum,
	      "max": _vm.maximum,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": (_vm.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.value = $event.target.value
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-unit"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('range-component', {
	    attrs: {
	      "min": _vm.field.minValue,
	      "max": _vm.field.maxValue
	    }
	  }), _c('br'), _c('input-number-component', {
	    class: {
	      'validation-field-error': _vm.hasError, 'validation-field-warning': _vm.hasWarning, 'validation-field-info': _vm.hasInfo
	    },
	    attrs: {
	      "name": _vm.fieldRef,
	      "defaultValue": _vm.cc_value,
	      "min": _vm.field.minValue,
	      "max": _vm.field.maxValue,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.valueChanged
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e()], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-dimension"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('range-component', {
	    attrs: {
	      "min": _vm.minUomized,
	      "max": _vm.maxUomized,
	      "uom": _vm.uom
	    }
	  }), _c('br'), _c('input-number-component', {
	    class: {
	      'validation-field-error': _vm.hasError, 'validation-field-warning': _vm.hasWarning, 'validation-field-info': _vm.hasInfo
	    },
	    attrs: {
	      "name": _vm.fieldRef,
	      "defaultValue": _vm.cc_value,
	      "min": _vm.minUomized,
	      "max": _vm.maxUomized
	    },
	    on: {
	      "value-changed": _vm.valueChanged
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e()], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "color-picker-field-widget"
	  }, [_c('div', [_c('filter-field-widget', {
	    attrs: {
	      "field": _vm.filter
	    },
	    on: {
	      "change-color-filter-values": _vm.filterUpdated
	    }
	  }), _vm._l((_vm.colorAFormated.range), function(range, rangeKey) {
	    return (_vm.rangeIsNotEmpty(_vm.colorAFormated, rangeKey)) ? _c('div', [_c('div', {
	      staticClass: "range-color-header-parts"
	    }, [_c('span', {
	      staticClass: "range-color-header-part title",
	      domProps: {
	        "textContent": _vm._s(range.label)
	      }
	    }), _c('span', {
	      staticClass: "range-color-header-part"
	    }, [_c('span', {
	      domProps: {
	        "textContent": _vm._s(range.priceindicator)
	      }
	    }), _vm._l((range.picto), function(picto) {
	      return _c('img', {
	        staticClass: "picto",
	        attrs: {
	          "src": picto
	        }
	      })
	    })], 2), (_vm.isThisRange(_vm.colorASelectedSummary, rangeKey)) ? _c('span', {
	      staticClass: "range-color-header-part color-summary",
	      domProps: {
	        "textContent": _vm._s(_vm.colorASelectedSummary.label)
	      }
	    }) : _vm._e()]), _c('div', _vm._l((_vm.colorByRangekey(_vm.colorAFormated, rangeKey)), function(color, colorKey) {
	      return (_vm.isVisible(colorKey, _vm.colorAFormated)) ? _c('label', {
	        staticClass: "round-color-input",
	        attrs: {
	          "title": color.label,
	          "for": ("colorA_" + colorKey)
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.colorASelected),
	          expression: "colorASelected"
	        }],
	        attrs: {
	          "type": "radio",
	          "name": "colorA",
	          "id": ("colorA_" + colorKey),
	          "disabled": color.outOfStock
	        },
	        domProps: {
	          "value": colorKey,
	          "checked": _vm._q(_vm.colorASelected, colorKey)
	        },
	        on: {
	          "change": function($event) {
	            _vm.colorASelected = colorKey
	          }
	        }
	      }), _c('div', {
	        staticClass: "img",
	        class: {
	          'selected': (_vm.colorASelected === colorKey && !color.outOfStock)
	        },
	        style: ({
	          'background': _vm.colorPictureStyleBackground(color.imageUrl, color.outOfStock)
	        })
	      })]) : _vm._e()
	    }))]) : _vm._e()
	  })], 2), (_vm.cc.config_1.product_reference !== 'PRD-14_store-californien') ? _c('div', {
	    staticClass: "another-color-container"
	  }, [(_vm.isTwoColorType) ? _c('div', {
	    staticClass: "add-more-color",
	    on: {
	      "click": function($event) {
	        _vm.changeColorType(_vm.threeColorType)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "add-more-color-text",
	    domProps: {
	      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorPicker.addColorPrefix)
	    }
	  }), _c('span', {
	    staticClass: "add-more-color-text-alt",
	    domProps: {
	      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorPicker.addColorColorCSuffix)
	    }
	  })]) : _vm._e(), (_vm.isThreeColorType) ? _c('div', {
	    staticClass: "remove-one-color"
	  }, [_c('div', {
	    staticClass: "remove-one-color-text",
	    domProps: {
	      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorPicker.removeColorCLeftButton)
	    },
	    on: {
	      "click": function($event) {
	        _vm.changeColorType(_vm.twoColorType)
	      }
	    }
	  }), _c('div', {
	    staticClass: "remove-one-color-text-alt",
	    domProps: {
	      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorPicker.removeColorRightButton)
	    },
	    on: {
	      "click": function($event) {
	        _vm.changeColorType(_vm.twoColorType)
	      }
	    }
	  }), (_vm.checkColorErrors('colorisC')) ? _c('div', {
	    staticClass: "remove-one-color-text-subtitle color-picker-summary-value-error fp-error--excl",
	    domProps: {
	      "innerHTML": _vm._s(_vm.checkColorErrors('colorisC'))
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "remove-one-color-text-subtitle"
	  }), _vm._l((_vm.colorCFormated.range), function(range, rangeKey) {
	    return (_vm.rangeIsNotEmpty(_vm.colorCFormated, rangeKey)) ? _c('div', [_c('div', {
	      staticClass: "range-color-header-parts"
	    }, [_c('span', {
	      staticClass: "range-color-header-part title",
	      domProps: {
	        "textContent": _vm._s(range.label)
	      }
	    }), _c('span', {
	      staticClass: "range-color-header-part"
	    }, [_c('span', {
	      domProps: {
	        "textContent": _vm._s(range.priceindicator)
	      }
	    }), _vm._l((range.picto), function(picto) {
	      return _c('img', {
	        staticClass: "picto",
	        attrs: {
	          "src": picto
	        }
	      })
	    })], 2), (_vm.isThisRange(_vm.colorCSelectedSummary, rangeKey)) ? _c('span', {
	      staticClass: "range-color-header-part color-summary",
	      domProps: {
	        "textContent": _vm._s(_vm.colorCSelectedSummary.label)
	      }
	    }) : _vm._e()]), _c('div', _vm._l((_vm.colorByRangekey(_vm.colorCFormated, rangeKey)), function(color, colorKey) {
	      return (_vm.isVisible(colorKey, _vm.colorCFormated)) ? _c('label', {
	        staticClass: "round-color-input",
	        attrs: {
	          "title": color.label,
	          "for": ("colorC_" + colorKey)
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.colorCSelected),
	          expression: "colorCSelected"
	        }],
	        attrs: {
	          "type": "radio",
	          "name": 'colorC',
	          "id": ("colorC_" + colorKey),
	          "disabled": color.outOfStock
	        },
	        domProps: {
	          "value": colorKey,
	          "checked": _vm._q(_vm.colorCSelected, colorKey)
	        },
	        on: {
	          "change": function($event) {
	            _vm.colorCSelected = colorKey
	          }
	        }
	      }), _c('div', {
	        staticClass: "img",
	        class: {
	          'selected': (_vm.colorCSelected === colorKey)
	        },
	        style: ({
	          'background': _vm.colorPictureStyleBackground(color.imageUrl, color.outOfStock)
	        })
	      })]) : _vm._e()
	    }))]) : _vm._e()
	  })], 2) : _vm._e()]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "selection-alt-choice-container",
	    class: _vm.cssClasses
	  }, _vm._l((_vm.options), function(value, valueRef) {
	    return (value.display) ? _c('label', {
	      staticClass: "selection-alt-choice-container-item",
	      class: {
	        'disabled': value.disabled
	      },
	      attrs: {
	        "value": valueRef,
	        "for": valueRef,
	        "disabled": value.disabled
	      }
	    }, [(_vm.checkLegacyOptions(valueRef)) ? _c('div', {
	      staticClass: "selection-alt-choice-picture-container"
	    }, [_c('img', {
	      class: {
	        'out-of-stock': true, 'selected': (_vm.selected === valueRef), 'single': (Object.keys(_vm.options).length == 1), 'bande-img': (valueRef === 'OPT-223_127-mm'), 'full-width': (_vm.fullWidth !== false)
	      },
	      attrs: {
	        "src": value.picture
	      }
	    }), (value.display) ? _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selected),
	        expression: "selected"
	      }],
	      attrs: {
	        "type": "radio",
	        "id": valueRef,
	        "name": valueRef,
	        "disabled": value.disabled
	      },
	      domProps: {
	        "value": valueRef,
	        "checked": _vm._q(_vm.selected, valueRef)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selected = valueRef
	        }
	      }
	    }) : _vm._e(), (_vm.checkLabelVisibility(valueRef)) ? _c('label', {
	      class: {
	        'selected': (_vm.selected === valueRef)
	      },
	      domProps: {
	        "textContent": _vm._s(value.label)
	      }
	    }) : _vm._e()]) : _vm._e()]) : _vm._e()
	  }))
	},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isDisplayed) ? _c('div', {
	    staticClass: "zoom-in-place zoom-component",
	    style: (_vm.zoomStyle),
	    on: {
	      "mousemove": function($event) {
	        $event.stopPropagation();
	        _vm.setZoomEvent(true, $event)
	      },
	      "mouseleave": function($event) {
	        $event.stopPropagation();
	        _vm.setZoomEvent(false)
	      },
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onClick($event)
	      }
	    }
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e(), _c('br'), _c('select-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.fieldValues,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('br'), _c('select-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.fieldValues,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  }), (_vm.displayModal) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e()], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection band-size"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": ""
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "selection-alt-choice-container cmd-side-container",
	    class: _vm.cssClasses
	  }, _vm._l((_vm.options), function(value, valueRef) {
	    return (value.display) ? _c('label', {
	      staticClass: "selection-alt-choice-container-item",
	      class: {
	        'selected': (_vm.selected === valueRef)
	      },
	      attrs: {
	        "value": valueRef,
	        "for": valueRef,
	        "disabled": value.disabled
	      }
	    }, [_c('div', {
	      staticClass: "selection-alt-choice-picture-container"
	    }, [_c('div', {
	      staticClass: "txt-button",
	      domProps: {
	        "textContent": _vm._s(value.label)
	      }
	    }), (value.display) ? _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selected),
	        expression: "selected"
	      }],
	      attrs: {
	        "type": "radio",
	        "id": valueRef,
	        "name": valueRef,
	        "disabled": value.disabled
	      },
	      domProps: {
	        "value": valueRef,
	        "checked": _vm._q(_vm.selected, valueRef)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selected = valueRef
	        }
	      }
	    }) : _vm._e()])]) : _vm._e()
	  }))
	},staticRenderFns: []}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "olst-tooltip"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isDisplayed),
	      expression: "isDisplayed"
	    }],
	    staticClass: "tooltip-container",
	    attrs: {
	      "transition": "tooltip"
	    }
	  }, [_c('div', {
	    staticClass: "tooltip-header",
	    domProps: {
	      "textContent": _vm._s(_vm.header)
	    }
	  }), _c('div', {
	    staticClass: "tooltip-image-container"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.image
	    }
	  })]), _c('div', {
	    staticClass: "tooltip-footer",
	    domProps: {
	      "textContent": _vm._s(_vm.footer)
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-unit"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('range-component', {
	    attrs: {
	      "min": _vm.field.minValue,
	      "max": _vm.field.maxValue
	    }
	  }), _c('br'), _c('input-number-component', {
	    class: {
	      'validation-field-error': _vm.hasError, 'validation-field-warning': _vm.hasWarning, 'validation-field-info': _vm.hasInfo
	    },
	    attrs: {
	      "name": _vm.fieldRef,
	      "defaultValue": _vm.cc_value,
	      "min": _vm.field.minValue,
	      "max": _vm.field.maxValue,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.valueChanged
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e()], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-unit"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('range-component', {
	    attrs: {
	      "min": _vm.field.minValue,
	      "max": _vm.field.maxValue
	    }
	  }), _c('br'), _c('input-number-component', {
	    class: {
	      'validation-field-error': _vm.hasError, 'validation-field-warning': _vm.hasWarning, 'validation-field-info': _vm.hasInfo
	    },
	    attrs: {
	      "name": _vm.fieldRef,
	      "defaultValue": _vm.cc_value,
	      "min": _vm.field.minValue,
	      "max": _vm.field.maxValue,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.valueChanged
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e()], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "color-picker-field-widget"
	  }, [_c('div', _vm._l((_vm.getRanges()), function(range) {
	    return _c('div', [_c('div', {
	      staticClass: "range-color-header-parts"
	    }, [_c('span', {
	      staticClass: "range-color-header-part title",
	      domProps: {
	        "textContent": _vm._s(range.label)
	      }
	    }), (_vm.isThisRange(_vm.selectedColor, range.key)) ? _c('span', {
	      staticClass: "range-color-header-part color-summary",
	      domProps: {
	        "innerHTML": _vm._s(_vm.getSummary())
	      }
	    }) : _vm._e()]), _c('div', _vm._l((_vm.colorByRangekey(_vm.colorAFormated, range.key)), function(color, colorKey) {
	      return (_vm.isVisible(colorKey, _vm.colorAFormated)) ? _c('label', {
	        staticClass: "round-color-input",
	        attrs: {
	          "title": color.label,
	          "for": ("colorA_" + colorKey)
	        }
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.colorASelected),
	          expression: "colorASelected"
	        }],
	        attrs: {
	          "type": "radio",
	          "name": "colorA",
	          "id": ("colorA_" + colorKey),
	          "disabled": color.outOfStock
	        },
	        domProps: {
	          "value": colorKey,
	          "checked": _vm._q(_vm.colorASelected, colorKey)
	        },
	        on: {
	          "change": function($event) {
	            _vm.colorASelected = colorKey
	          }
	        }
	      }), _c('div', {
	        staticClass: "img",
	        class: {
	          'selected': (_vm.colorASelected === colorKey && !color.outOfStock)
	        },
	        style: ({
	          'background': _vm.colorPictureStyleBackground(color.imageZoomUrl, color.outOfStock)
	        })
	      }, [((_vm.colorASelected === colorKey && !color.outOfStock)) ? _c('div', {
	        staticClass: "check-mark"
	      }) : _vm._e()])]) : _vm._e()
	    }))])
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filter-field-widget"
	  }, [_c('div', {
	    staticClass: "filter-field-widget-header"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.filterSelectedValue),
	      expression: "filterSelectedValue"
	    }],
	    staticClass: "colorpicker-filter-field-alt",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.filterSelectedValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.hookedFilterValues), function(filterValue) {
	    return _c('option', {
	      domProps: {
	        "value": filterValue.value,
	        "textContent": _vm._s(filterValue.label)
	      }
	    })
	  })), _c('a', {
	    staticClass: "compare-fabrics-link doc-link scrollAnchor",
	    attrs: {
	      "href": "#compare_fabrics_tamisant",
	      "target": _vm._blank
	    },
	    domProps: {
	      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.colorFilter.compareMaterialLink)
	    }
	  })]), _c('div', {
	    staticClass: "filter-field-widget-tags"
	  }, _vm._l((_vm.taggedFilters), function(taggedFilter) {
	    return _c('div', {
	      staticClass: "filter-field-widget-tag",
	      domProps: {
	        "textContent": _vm._s(taggedFilter.label)
	      },
	      on: {
	        "click": function($event) {
	          _vm.removeTag(taggedFilter.value)
	        }
	      }
	    })
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "olst-range-component olst-field-label-subtitle",
	    domProps: {
	      "textContent": _vm._s(_vm.rangeHumanized)
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isFieldDisable()) ? _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable(),
	      "cssClasses": _vm.getGrid()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "gallery"
	  }, [_c('gallery', {
	    attrs: {
	      "imageList": _vm.imageList,
	      "selectedImage": _vm.selected
	    },
	    on: {
	      "select-image": _vm.selectImage
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-dimension olst-field-dimension-alt"
	  }, [_c('div', {
	    staticClass: "dimension-header-label"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label dimension-header-label-title",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('span', {
	    staticClass: "dimension-header-label-range",
	    domProps: {
	      "textContent": _vm._s(("(max " + (_vm.maxUomized + _vm.uom) + ")"))
	    }
	  })], 1), _c('div', {
	    staticClass: "input-text-heavy-sized"
	  }, [_c('div', {
	    staticClass: "fp-input"
	  }, [_c('label', {
	    staticClass: "fp-unit",
	    domProps: {
	      "textContent": _vm._s(_vm.uom)
	    }
	  }), _c('input-number-component', {
	    class: {
	      'validation-field-error': _vm.hasError, 'validation-field-warning': _vm.hasWarning, 'validation-field-info': _vm.hasInfo
	    },
	    attrs: {
	      "name": _vm.fieldRef,
	      "defaultValue": _vm.cc_value,
	      "min": _vm.minUomized,
	      "max": _vm.maxUomized,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.valueChanged
	    }
	  })], 1)])]), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', _vm._l((messages), function(message) {
	      return (_vm.isTypeError(key)) ? _c('div', {
	        staticClass: "dimension-info-error"
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1) : _vm._e()
	    })) : _vm._e()
	  }), _c('div', {
	    staticClass: "olst-field-dimension olst-field-dimension-alt"
	  }, [_c('div', {
	    staticClass: "dimension-label-subtitle",
	    domProps: {
	      "innerHTML": _vm._s(_vm.field.subtitle)
	    }
	  })]), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation olst-field-validation-alt"
	    }, _vm._l((messages), function(message) {
	      return (!_vm.isTypeError(key)) ? _c('div', {
	        staticClass: "dimension-info-alt",
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1) : _vm._e()
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected),
	      expression: "selected"
	    }],
	    attrs: {
	      "id": _vm.name,
	      "name": _vm.name,
	      "disabled": _vm.disabled
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.options), function(value, valueRef) {
	    return (value.display) ? _c('option', {
	      attrs: {
	        "disabled": value.disabled
	      },
	      domProps: {
	        "value": valueRef,
	        "textContent": _vm._s(value.label)
	      }
	    }) : _vm._e()
	  }))
	},staticRenderFns: []}

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "gallery-block",
	    attrs: {
	      "id": "olst-gallery"
	    }
	  }, [_c('gallery-block', {
	    attrs: {
	      "imageList": _vm.imageList,
	      "debug": _vm.debug,
	      "isMobile": _vm.isMobile
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-virtualform': true, 'olst-virtualform-min': (_vm.isAbtested || _vm.isVrAbtested), 'olst-mobile-device': _vm.isMobile
	    }
	  }, [_c('div', [(!_vm.isAbtested && !_vm.isVrAbtested) ? _c('ol', _vm._l((_vm.filterRecipeFields), function(field, fieldKey, fieldIndice) {
	    return (_vm.fieldIsNotHidden(fieldKey)) ? _c('li', {
	      class: _vm.abTestHiddenFields(fieldKey) ? 'olst-hidden' : '',
	      attrs: {
	        "id": fieldKey
	      }
	    }, [_c('div', {
	      staticClass: "olst-base-field"
	    }, [_c(_vm.renderingUnitToLoad(field, fieldKey), {
	      tag: "component",
	      attrs: {
	        "mint": _vm.mint,
	        "version": _vm.version,
	        "productReference": _vm.productReference,
	        "fieldRef": fieldKey,
	        "field": field,
	        "cc_value": _vm.fieldValueInCC(fieldKey),
	        "uom": _vm.uom
	      },
	      on: {
	        "field-changed": _vm.fieldHasChanged
	      }
	    })], 1)]) : _vm._e()
	  })) : _vm._e(), (_vm.isAbtested) ? _c('div', _vm._l((_vm.filterRecipeGroupedFields()), function(filterRecipeFieldsItems, index) {
	    return _c('div', [_c('div', {
	      staticClass: "accordion",
	      class: (filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close'
	    }, [_c('label', {
	      staticClass: "grouped-fields-title",
	      attrs: {
	        "for": filterRecipeFieldsItems.items[0].fieldKey
	      },
	      domProps: {
	        "innerHTML": _vm._s((index + 1) + '. ' + filterRecipeFieldsItems.label)
	      },
	      on: {
	        "click": function($event) {
	          _vm.accordionToggle(filterRecipeFieldsItems.key)
	        }
	      }
	    }), (filterRecipeFieldsItems.key === 'COLORIS' && filterRecipeFieldsItems.accordion.open && _vm.colorPickerHasError()) ? _c('label', {
	      staticClass: "color-picker-summary-value-error fp-error--excl",
	      domProps: {
	        "innerHTML": _vm._s(_vm.colorPickerErrorSummary)
	      }
	    }) : _vm._e(), _c('div', {
	      staticClass: "accordion-switch",
	      class: (filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close',
	      domProps: {
	        "textContent": _vm._s((filterRecipeFieldsItems.accordion.open === true) ? 'Fermer' : 'Modifier')
	      },
	      on: {
	        "click": function($event) {
	          _vm.accordionToggle(filterRecipeFieldsItems.key)
	        }
	      }
	    }), (filterRecipeFieldsItems.key === 'COLORIS') ? _c('div', {
	      staticClass: "olst-base-field-closed color-picker-summary-color-container",
	      on: {
	        "click": function($event) {
	          _vm.accordionToggle(filterRecipeFieldsItems.key)
	        }
	      }
	    }, [(_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-143_coloris-1', _vm.cc.config_1.prefilled_values['CH-143_coloris-1']))) ? _c('div', {
	      staticClass: "color-picker-summary-color"
	    }, [(_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-143_coloris-1', _vm.cc.config_1.prefilled_values['CH-143_coloris-1']))) ? _c('div', {
	      staticClass: "round-color-img",
	      style: ({
	        'background': _vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-143_coloris-1', _vm.cc.config_1.prefilled_values['CH-143_coloris-1']))
	      })
	    }) : _vm._e(), (_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-144_coloris-2', _vm.cc.config_1.prefilled_values['CH-144_coloris-2']))) ? _c('div', {
	      staticClass: "round-color-img",
	      style: ({
	        'background': _vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-144_coloris-2', _vm.cc.config_1.prefilled_values['CH-144_coloris-2']))
	      })
	    }) : _vm._e(), (_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-145_coloris-3', _vm.cc.config_1.prefilled_values['CH-145_coloris-3']))) ? _c('div', {
	      staticClass: "round-color-img",
	      style: ({
	        'background': _vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-145_coloris-3', _vm.cc.config_1.prefilled_values['CH-145_coloris-3']))
	      })
	    }) : _vm._e()]) : _vm._e(), _c('div', {
	      staticClass: "color-picker-summary-text"
	    }, [_c('div', {
	      staticClass: "color-picker-summary"
	    }, [(_vm.humanized['Type de toile'] || _vm.humanized['Gamme Client']) ? _c('label', {
	      staticClass: "color-picker-summary-title",
	      domProps: {
	        "textContent": _vm._s('Toile : ')
	      }
	    }) : _vm._e(), _c('label', {
	      staticClass: "color-picker-summary-value",
	      domProps: {
	        "textContent": _vm._s(_vm.humanized['Type de toile'] || _vm.humanized['Gamme Client'])
	      }
	    })]), _c('div', {
	      staticClass: "color-picker-summary"
	    }, [_c('label', {
	      staticClass: "color-picker-summary-title",
	      domProps: {
	        "textContent": _vm._s('Coloris : ')
	      }
	    }), _vm._l((_vm.groupedFieldSummary(filterRecipeFieldsItems.key)), function(field) {
	      return _c('label', {
	        staticClass: "color-picker-summary-value",
	        domProps: {
	          "textContent": _vm._s(field.value)
	        }
	      })
	    }), (_vm.colorPickerHasError()) ? _c('label', {
	      staticClass: "color-picker-summary-value-error fp-error--excl",
	      domProps: {
	        "innerHTML": _vm._s(_vm.colorPickerErrorSummary)
	      }
	    }) : _vm._e()], 2)])]) : _vm._e(), (filterRecipeFieldsItems.key !== 'COLORIS') ? _c('div', {
	      staticClass: "olst-base-field-closed",
	      on: {
	        "click": function($event) {
	          _vm.accordionToggle(filterRecipeFieldsItems.key)
	        }
	      }
	    }, _vm._l((_vm.groupedFieldSummary(filterRecipeFieldsItems.key)), function(field) {
	      return _c('div', {
	        staticClass: "olst-base-field-closed-summary-item"
	      }, [_c('label', {
	        staticClass: "olst-base-field-closed-summary-item-label",
	        domProps: {
	          "textContent": _vm._s(field.label)
	        }
	      }), _c('label', {
	        staticClass: "olst-base-field-closed-summary-item-value",
	        domProps: {
	          "textContent": _vm._s(field.value)
	        }
	      }), (field.error) ? _c('label', {
	        staticClass: "olst-base-field-closed-summary-item-error fp-error--excl",
	        domProps: {
	          "textContent": _vm._s(field.error)
	        }
	      }) : _vm._e()])
	    })) : _vm._e(), (filterRecipeFieldsItems.key === 'DIMENSIONSDUSTORE') ? _c('div', {
	      staticClass: "olst-base-multi-field"
	    }, [_c('dimensions-field-widget', {
	      attrs: {
	        "cc": _vm.cc,
	        "mint": _vm.mint,
	        "version": _vm.version,
	        "productReference": _vm.productReference,
	        "cc_value": _vm.fieldValueInCC(_vm.fieldKey),
	        "fieldHasChanged": _vm.fieldHasChanged,
	        "uom": _vm.uom,
	        "widthField": _vm.getWidthField,
	        "heightField": _vm.getHeightField,
	        "widthFieldRef": _vm.getDimInfo(_vm.productReference).widthFieldRef,
	        "heightFieldRef": _vm.getDimInfo(_vm.productReference).heightFieldRef,
	        "widthFieldLabel": _vm.getDimInfo(_vm.productReference).widthLabel,
	        "widthFieldSubtitle": _vm.getDimInfo(_vm.productReference).widthSubtitle,
	        "heightFieldLabel": _vm.getDimInfo(_vm.productReference).heightLabel,
	        "heightFieldSubtitle": _vm.getDimInfo(_vm.productReference).heightSubtitle,
	        "docLink": _vm.getDimInfo(_vm.productReference).docLink
	      },
	      on: {
	        "field-changed": _vm.fieldHasChanged
	      }
	    })], 1) : _vm._e(), (filterRecipeFieldsItems.key === 'MECANISME') ? _c('div', {
	      staticClass: "olst-base-multi-field"
	    }, [_c('div', {
	      staticClass: "olst-base-field"
	    }, [_c('rail-field-widget', {
	      attrs: {
	        "cc": _vm.cc,
	        "railTypeField": _vm.getRailTypeField,
	        "railColorField": _vm.getRailColorField
	      },
	      on: {
	        "change-rail-color-type": _vm.caliWidgetRailChanged
	      }
	    })], 1)]) : _vm._e(), (filterRecipeFieldsItems.key === 'COLORIS') ? _c('div', {
	      staticClass: "olst-base-multi-field"
	    }, [_c('color-picker-field-widget', {
	      attrs: {
	        "cc": _vm.cc,
	        "mint": _vm.mint,
	        "version": _vm.version,
	        "productReference": _vm.productReference,
	        "cc_value": _vm.fieldValueInCC(_vm.fieldKey),
	        "uom": _vm.uom,
	        "filter": _vm.getFilterField,
	        "colorisA": _vm.getColorisAField,
	        "colorisB": _vm.getColorisBField,
	        "colorisC": _vm.getColorisCField,
	        "totalColorVariation": _vm.getTotalColorVariationField
	      },
	      on: {
	        "field-changed": _vm.fieldHasChanged
	      }
	    })], 1) : _vm._e(), _vm._l((filterRecipeFieldsItems.items), function(field) {
	      return (_vm.fieldIsNotHidden(field.fieldKey) && filterRecipeFieldsItems.key !== 'MECANISME' && filterRecipeFieldsItems.key !== 'DIMENSIONSDUSTORE' && filterRecipeFieldsItems.key !== 'COLORIS') ? _c('div', [_c('div', {
	        staticClass: "olst-base-field"
	      }, [_c(_vm.renderingUnitToLoad(field, field.fieldKey), {
	        tag: "component",
	        attrs: {
	          "mint": _vm.mint,
	          "version": _vm.version,
	          "productReference": _vm.productReference,
	          "fieldRef": field.fieldKey,
	          "field": field,
	          "cc_value": _vm.fieldValueInCC(field.fieldKey),
	          "uom": _vm.uom
	        },
	        on: {
	          "field-changed": _vm.fieldHasChanged
	        }
	      })], 1)]) : _vm._e()
	    })], 2), (_vm.filterRecipeGroupedFields().length !== index + 1) ? _c('div', {
	      staticClass: "bloc-separator"
	    }) : _vm._e()])
	  })) : _vm._e(), (_vm.isVrAbtested) ? _c('div', [_vm._l((_vm.VoletRoulantFilterRecipeGroupedFields()), function(filterRecipeFieldsItems, index) {
	    return _c('div', {
	      class: {
	        'olst-hidden': _vm.isHiddenGroup(filterRecipeFieldsItems.key)
	      },
	      attrs: {
	        "id": filterRecipeFieldsItems.key
	      }
	    }, [_c('div', {
	      staticClass: "accordion",
	      class: {
	        'open': (filterRecipeFieldsItems.accordion.open === true), 'close': (filterRecipeFieldsItems.accordion.open !== true), 'olst-hidden': (filterRecipeFieldsItems.hidden === true)
	      }
	    }, [_c('label', {
	      staticClass: "grouped-fields-title",
	      attrs: {
	        "for": filterRecipeFieldsItems.items[0].fieldKey
	      },
	      domProps: {
	        "innerHTML": _vm._s((index + 1) + '. ' + filterRecipeFieldsItems.label)
	      },
	      on: {
	        "click": function($event) {
	          _vm.accordionVrToggle(filterRecipeFieldsItems.key)
	        }
	      }
	    }), (filterRecipeFieldsItems.key === 'COLORIS' && filterRecipeFieldsItems.accordion.open && _vm.vrColorPickerHasError()) ? _c('label', {
	      staticClass: "color-picker-summary-value-error fp-error--excl",
	      domProps: {
	        "innerHTML": _vm._s(_vm.vrColorPickerErrorSummary)
	      }
	    }) : _vm._e(), _c('div', {
	      staticClass: "accordion-switch",
	      class: (filterRecipeFieldsItems.accordion.open === true) ? 'open' : 'close',
	      domProps: {
	        "textContent": _vm._s((filterRecipeFieldsItems.accordion.open === true) ? 'Fermer' : 'Modifier')
	      },
	      on: {
	        "click": function($event) {
	          _vm.accordionVrToggle(filterRecipeFieldsItems.key)
	        }
	      }
	    }), (filterRecipeFieldsItems.key === 'COLORIS') ? _c('div', {
	      staticClass: "olst-base-field-closed color-picker-summary-color-container",
	      on: {
	        "click": function($event) {
	          _vm.accordionVrToggle(filterRecipeFieldsItems.key)
	        }
	      }
	    }, [(_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-461_coloris', _vm.cc.config_1.prefilled_values['CH-461_coloris']))) ? _c('div', {
	      staticClass: "color-picker-summary-color"
	    }, [(_vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-461_coloris', _vm.cc.config_1.prefilled_values['CH-461_coloris']))) ? _c('div', {
	      staticClass: "round-color-img",
	      style: ({
	        'background': _vm.colorPictureStyleBackground(_vm.getRelatedColorPicture('CH-461_coloris', _vm.cc.config_1.prefilled_values['CH-461_coloris']))
	      })
	    }) : _vm._e()]) : _vm._e(), _c('div', {
	      staticClass: "color-picker-summary-text"
	    }, [_c('div', {
	      staticClass: "color-picker-summary"
	    }, [_c('label', {
	      staticClass: "color-picker-summary-title",
	      domProps: {
	        "textContent": _vm._s('Matière : ')
	      }
	    }), _c('label', {
	      staticClass: "color-picker-summary-value",
	      domProps: {
	        "textContent": _vm._s(_vm.humanized['Matière'])
	      }
	    })]), _c('div', {
	      staticClass: "color-picker-summary"
	    }, [_c('label', {
	      staticClass: "color-picker-summary-title",
	      domProps: {
	        "textContent": _vm._s('Coloris : ')
	      }
	    }), _c('label', {
	      staticClass: "color-picker-summary-value",
	      domProps: {
	        "textContent": _vm._s(_vm.humanized['Coloris'])
	      }
	    }), (_vm.vrColorPickerHasError()) ? _c('label', {
	      staticClass: "color-picker-summary-value-error fp-error--excl",
	      domProps: {
	        "innerHTML": _vm._s(_vm.vrColorPickerErrorSummary)
	      }
	    }) : _vm._e()])])]) : _vm._e(), (filterRecipeFieldsItems.key !== 'COLORIS') ? _c('div', {
	      staticClass: "olst-base-field-closed",
	      on: {
	        "click": function($event) {
	          _vm.accordionVrToggle(filterRecipeFieldsItems.key)
	        }
	      }
	    }, _vm._l((_vm.groupedFieldSummary(filterRecipeFieldsItems.key, _vm.productReference)), function(field) {
	      return _c('div', {
	        staticClass: "olst-base-field-closed-summary-item"
	      }, [(_vm.fieldIsVisible(field.key)) ? _c('label', {
	        staticClass: "olst-base-field-closed-summary-item-label",
	        domProps: {
	          "textContent": _vm._s(field.label)
	        }
	      }) : _vm._e(), (_vm.fieldIsVisible(field.key)) ? _c('label', {
	        staticClass: "olst-base-field-closed-summary-item-value",
	        domProps: {
	          "textContent": _vm._s(field.value)
	        }
	      }) : _vm._e(), (field.error) ? _c('label', {
	        staticClass: "olst-base-field-closed-summary-item-error fp-error--excl",
	        domProps: {
	          "textContent": _vm._s(field.error)
	        }
	      }) : _vm._e()])
	    })) : _vm._e(), (filterRecipeFieldsItems.key === 'DIMENSIONSDUVOLET') ? _c('div', {
	      staticClass: "olst-base-multi-field"
	    }, [_c('dimensions-field-widget', {
	      attrs: {
	        "cc": _vm.cc,
	        "mint": _vm.mint,
	        "version": _vm.version,
	        "productReference": _vm.productReference,
	        "cc_value": _vm.fieldValueInCC(_vm.fieldKey),
	        "fieldHasChanged": _vm.fieldHasChanged,
	        "uom": _vm.uom,
	        "widthField": _vm.getVrWidthField,
	        "heightField": _vm.getVrHeightField,
	        "widthFieldRef": _vm.getDimInfo(_vm.productReference).widthFieldRef,
	        "heightFieldRef": _vm.getDimInfo(_vm.productReference).heightFieldRef,
	        "widthFieldLabel": _vm.getDimInfo(_vm.productReference).widthLabel,
	        "widthFieldSubtitle": _vm.getDimInfo(_vm.productReference).widthSubtitle,
	        "heightFieldLabel": _vm.getDimInfo(_vm.productReference).heightLabel,
	        "heightFieldSubtitle": _vm.getDimInfo(_vm.productReference).heightSubtitle,
	        "docLink": _vm.getDimInfo(_vm.productReference).docLink
	      },
	      on: {
	        "field-changed": _vm.fieldHasChanged
	      }
	    })], 1) : _vm._e(), (filterRecipeFieldsItems.key === 'COLORIS') ? _c('div', {
	      staticClass: "olst-base-multi-field"
	    }, [_c('vr-color-picker-field-widget', {
	      attrs: {
	        "cc": _vm.cc,
	        "mint": _vm.mint,
	        "version": _vm.version,
	        "productReference": _vm.productReference,
	        "cc_value": _vm.fieldValueInCC(_vm.fieldKey),
	        "uom": _vm.uom,
	        "colorisA": _vm.getVrColorisAField,
	        "validation": _vm.validation
	      },
	      on: {
	        "field-changed": _vm.fieldHasChanged
	      }
	    })], 1) : _vm._e(), _vm._l((filterRecipeFieldsItems.items), function(field) {
	      return (_vm.fieldIsNotHidden(field.fieldKey) && filterRecipeFieldsItems.key !== 'DIMENSIONSDUVOLET' && filterRecipeFieldsItems.key !== 'COLORIS') ? _c('div', [_c('div', {
	        staticClass: "olst-base-field",
	        class: field.fieldKey
	      }, [_c(_vm.renderingUnitToLoad(field, field.fieldKey), {
	        tag: "component",
	        attrs: {
	          "mint": _vm.mint,
	          "version": _vm.version,
	          "productReference": _vm.productReference,
	          "validation": _vm.validation,
	          "cc": _vm.cc,
	          "fieldRef": field.fieldKey,
	          "field": field,
	          "cc_value": _vm.fieldValueInCC(field.fieldKey),
	          "uom": _vm.uom
	        },
	        on: {
	          "field-changed": _vm.fieldHasChanged
	        }
	      })], 1)]) : _vm._e()
	    })], 2), (_vm.VoletRoulantFilterRecipeGroupedFields().length !== index + 1 && _vm.VoletRoulantFilterRecipeGroupedFields().length !== index + 2) ? _c('div', {
	      staticClass: "bloc-separator"
	    }) : _vm._e()])
	  }), _vm._l((_vm.validation.info['CH-467_anti-vol']), function(message, key) {
	    return _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, [_c('div', {
	      staticClass: "olst-field-infos olst-field-info",
	      domProps: {
	        "textContent": _vm._s(message)
	      }
	    })])
	  })], 2) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [(!_vm.isFieldDisable()) ? _c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.getLabel(_vm.field)
	    }
	  }), _c('select-with-text-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1) : _vm._e(), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('img', {
	    attrs: {
	      "src": _vm.src,
	      "alt": _vm.name
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onClick($event)
	      },
	      "mouseenter": _vm.mouseEnter,
	      "mouseOver": _vm.mouseOver,
	      "mouseMove": _vm.mouseMove,
	      "mouseleave": _vm.mouseLeave
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable(),
	      "cssClasses": "flex-3-cols"
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "data-logger",
	    class: {
	      'logger-absolute': _vm.toggle, 'logger-inline': !_vm.toggle
	    }
	  }, [_c('header', [_c('button', {
	    domProps: {
	      "textContent": _vm._s(_vm.loggerTitle)
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleLogger()
	      }
	    }
	  }), (_vm.toggle) ? _c('span', [_c('button', {
	    domProps: {
	      "textContent": _vm._s('Paste Object to console')
	    },
	    on: {
	      "click": function($event) {
	        _vm.pasteToConsole()
	      }
	    }
	  }), _c('button', {
	    domProps: {
	      "textContent": _vm._s('Paste Json to console')
	    },
	    on: {
	      "click": function($event) {
	        _vm.pasteToConsoleInJson()
	      }
	    }
	  })]) : _vm._e()]), (_vm.toggle) ? _c('article', [_c('small', {
	    domProps: {
	      "textContent": _vm._s(_vm.dataLength)
	    }
	  }), _c('pre', {
	    domProps: {
	      "textContent": _vm._s(_vm.data)
	    }
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [(!_vm.isFieldDisable()) ? _c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.getValue(),
	      "disabled": _vm.isFieldDisable(),
	      "cssClasses": "flex-5-cols"
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1) : _vm._e(), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key)
	        }
	      }, [(!_vm.isTypeInfo(key)) ? _c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      }) : _vm._e()], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "olst-field-modal"
	  }, [_c('div', {
	    staticClass: "modal-parent",
	    attrs: {
	      "id": _vm.name + '-modal'
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade-mask"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isDisplayed),
	      expression: "isDisplayed"
	    }],
	    staticClass: "modal-mask",
	    on: {
	      "click": function($event) {
	        _vm.closeModal()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('transition', {
	    attrs: {
	      "name": "slide-modal"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.isDisplayed),
	      expression: "isDisplayed"
	    }],
	    staticClass: "modal-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return (function () {})($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "modal-close",
	    on: {
	      "click": function($event) {
	        _vm.closeModal()
	      }
	    }
	  })]), _c('div', {
	    staticClass: "modal-content clearfix"
	  }, [_vm._t("default")], 2)])])], 1)])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.value),
	      expression: "value"
	    }],
	    attrs: {
	      "type": "text",
	      "name": _vm.name
	    },
	    domProps: {
	      "value": (_vm.value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.value = $event.target.value
	      }
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "olst-field-checkbox-label"
	  }, [_c('label', {
	    staticClass: "olst-field-checkbox-label-group",
	    class: {
	      'olst-field-checkbox-label-group-open': _vm.hideFilters
	    },
	    attrs: {
	      "for": _vm.name
	    },
	    domProps: {
	      "textContent": _vm._s(_vm.getFilterName)
	    },
	    on: {
	      "click": _vm.labelClicked
	    }
	  })]), _c('div', [_vm._l((_vm.checkboxes), function(checkbox, index) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (!_vm.hideFilters),
	        expression: "!hideFilters"
	      }],
	      class: {
	        'olst-checkbox-all checkbox-check-all': checkbox.isAllCheckbox, 'olst-checkbox': !checkbox.isAllCheckbox
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.checkedCheckboxed),
	        expression: "checkedCheckboxed"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "name": checkbox.key,
	        "id": checkbox.key
	      },
	      domProps: {
	        "value": checkbox.key,
	        "checked": Array.isArray(_vm.checkedCheckboxed) ? _vm._i(_vm.checkedCheckboxed, checkbox.key) > -1 : (_vm.checkedCheckboxed)
	      },
	      on: {
	        "change": [function($event) {
	          var $$a = _vm.checkedCheckboxed,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = checkbox.key,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.checkedCheckboxed = $$a.concat([$$v]))
	            } else {
	              $$i > -1 && (_vm.checkedCheckboxed = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.checkedCheckboxed = $$c
	          }
	        }, function($event) {
	          checkbox.onClick(checkbox.key)
	        }]
	      }
	    }), _c('label', {
	      staticClass: "olst-field-checkbox-label olst-field-checkbox-label-item",
	      attrs: {
	        "for": checkbox.key
	      },
	      domProps: {
	        "textContent": _vm._s(checkbox.label)
	      }
	    })])
	  }), _c('div', {
	    staticClass: "olst-clear"
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dimensions-field-widget"
	  }, [_c('div', [_c('a', {
	    staticClass: "doc-link doc-link-pdf",
	    attrs: {
	      "href": _vm.docLink,
	      "target": "_blank"
	    },
	    domProps: {
	      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.dimension.docLink)
	    }
	  })]), _c('div', {
	    staticClass: "double-dimension-field-container"
	  }, [_c('div', {
	    staticClass: "double-dimension-field-item"
	  }, [_c('Dimension', {
	    attrs: {
	      "field": _vm.hookedWidthField,
	      "mint": _vm.mint,
	      "fieldRef": _vm.hookedWidthField.chKey,
	      "cc_value": _vm.getCcWidthValue,
	      "uom": _vm.uom
	    },
	    on: {
	      "field-changed": _vm.fieldHasChanged
	    }
	  })], 1), _c('div', {
	    staticClass: "double-dimension-field-item"
	  }, [_c('Dimension', {
	    attrs: {
	      "field": _vm.hookedHeightField,
	      "mint": _vm.mint,
	      "fieldRef": _vm.hookedHeightField.chKey,
	      "cc_value": _vm.getCcHeightValue,
	      "uom": _vm.uom
	    },
	    on: {
	      "field-changed": _vm.fieldHasChanged
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-dimension"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('range-component', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.minUomized && _vm.maxUomized),
	      expression: "minUomized && maxUomized"
	    }],
	    attrs: {
	      "min": _vm.minUomized,
	      "max": _vm.maxUomized,
	      "uom": _vm.uom
	    }
	  }), _c('br'), _c('input-number-component', {
	    class: {
	      'validation-field-error': _vm.hasError, 'validation-field-warning': _vm.hasWarning, 'validation-field-info': _vm.hasInfo
	    },
	    attrs: {
	      "name": _vm.fieldRef,
	      "defaultValue": _vm.cc_value,
	      "min": _vm.minUomized,
	      "max": _vm.maxUomized,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.valueChanged
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e()], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "olst-text-component"
	  }, [_vm._v(_vm._s(_vm.text))])
	},staticRenderFns: []}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "olst-range-component olst-field-label-subtitle",
	    domProps: {
	      "textContent": _vm._s(_vm.rangeHumanized)
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "olst-field-modal"
	  }, [_c('span', {
	    staticClass: "modal-open",
	    attrs: {
	      "name": _vm.name + 'Button'
	    },
	    on: {
	      "click": _vm.toggle
	    }
	  }), _c('div', {
	    staticClass: "modal-parent",
	    attrs: {
	      "id": _vm.name + '-modal'
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade-mask"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.visible),
	      expression: "visible"
	    }],
	    staticClass: "modal-mask",
	    on: {
	      "click": function($event) {
	        _vm.closeModal()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('transition', {
	    attrs: {
	      "name": "slide-modal"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.visible),
	      expression: "visible"
	    }],
	    staticClass: "modal-container"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "modal-close",
	    on: {
	      "click": function($event) {
	        _vm.toggle()
	      }
	    }
	  })]), _c('div', {
	    staticClass: "modal-content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.tooltip)
	    }
	  })])])], 1)])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    attrs: {
	      "id": _vm.name,
	      "name": _vm.name
	    },
	    domProps: {
	      "textContent": _vm._s(_vm.text)
	    },
	    on: {
	      "click": _vm.onClick
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.isActive) ? _c('div', {
	    staticClass: "zoom-separated zoom-component"
	  }, [_c('div', {
	    staticClass: "mouse-tracker",
	    on: {
	      "mousemove": function($event) {
	        $event.stopPropagation();
	        _vm.setZoomEvent(true, $event)
	      },
	      "mouseleave": function($event) {
	        $event.stopPropagation();
	        _vm.setZoomEvent(false)
	      },
	      "click": _vm.onClick
	    }
	  }), (_vm.event) ? _c('div', {
	    staticClass: "zoom-lens",
	    style: ({
	      left: _vm.event.position.x + 'px',
	      top: _vm.event.position.y + 'px',
	      width: _vm.event.size + 'px',
	      height: _vm.event.size + 'px'
	    })
	  }) : _vm._e(), _c('div', {
	    staticClass: "zoom-overlay",
	    style: (_vm.zoomStyle)
	  })]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), _c('br'), _c('select-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.fieldValues,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable()
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  }), (_vm.displayModal) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e()], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', {
	    staticClass: "olst-label-component",
	    attrs: {
	      "for": _vm.name
	    }
	  }, [_vm._v(_vm._s(_vm.text))])
	},staticRenderFns: []}

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "id": "olst-application"
	    }
	  }, [_c('virtual-form', {
	    attrs: {
	      "product-ref": _vm.recipe.product_ref,
	      "recipe": _vm.recipe,
	      "bundle": _vm.bundle,
	      "uom": _vm.uom,
	      "version": _vm.version,
	      "mint": _vm.mint,
	      "debug": _vm.debug,
	      "isMobile": _vm.isMobile
	    },
	    on: {
	      "cc-changed": _vm.ccDispatchChanged
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-selection"
	  }, [_c('label-component', {
	    staticClass: "olst-field-label olst-field-label-a-b",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.getLabel()
	    }
	  }), _c('select-with-picture-component', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "options": _vm.injectPictureInOption,
	      "defaultField": _vm.cc_value,
	      "disabled": _vm.isFieldDisable(),
	      "hideLabel": true,
	      "cssClasses": "flex-5-cols"
	    },
	    on: {
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation-picture-field-alt"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        staticClass: "olst-field-info",
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "rail-field-widget"
	  }, [_c('div', [_c('a', {
	    staticClass: "doc-link scrollAnchor",
	    attrs: {
	      "href": "#mecanisme",
	      "target": _vm._blank
	    },
	    domProps: {
	      "textContent": _vm._s(_vm.frText.abTest.prd14.variationB.fields.railType.compareRailLink)
	    }
	  })]), _vm._l((_vm.adaptedRailTypes()), function(adaptedRailType) {
	    return _c('div', [_c('div', {
	      staticClass: "rail-type-title"
	    }, [_c('div', {
	      staticClass: "rail-type-title-part"
	    }, [_c('span', {
	      staticClass: "title",
	      domProps: {
	        "textContent": _vm._s(adaptedRailType.opt.label)
	      }
	    }), (adaptedRailType.subTitle) ? _c('span', {
	      staticClass: "sub-title",
	      domProps: {
	        "textContent": _vm._s(adaptedRailType.subTitle)
	      }
	    }) : _vm._e()]), _c('div', {
	      staticClass: "rail-type-title-part",
	      domProps: {
	        "textContent": _vm._s(adaptedRailType.priceIndicator)
	      }
	    }), (adaptedRailType.colorSumary) ? _c('div', {
	      staticClass: "rail-type-title-part"
	    }, [(adaptedRailType.colorSumary) ? _c('span', {
	      staticClass: "color-summary",
	      domProps: {
	        "textContent": _vm._s(adaptedRailType.colorSumary)
	      }
	    }) : _vm._e()]) : _vm._e()]), _c('div', _vm._l((adaptedRailType.relatedColorOpt), function(railColor) {
	      return _c('div', {
	        staticClass: "color-picto-hexa-container"
	      }, [_c('label', {
	        staticClass: "color-picto-hexa",
	        class: {
	          'selected': (_vm.selected === railColor.colorOptKey)
	        },
	        style: ({
	          'background-color': railColor.pictureColor,
	          'border-color': (_vm.selected === railColor.colorOptKey) ? null : railColor.pictureBorderColor
	        }),
	        attrs: {
	          "for": railColor.colorOptKey
	        }
	      }), _c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (_vm.selected),
	          expression: "selected"
	        }],
	        attrs: {
	          "type": "radio",
	          "id": railColor.colorOptKey,
	          "name": 'railFieldWidget'
	        },
	        domProps: {
	          "value": railColor.colorOptKey,
	          "checked": _vm._q(_vm.selected, railColor.colorOptKey)
	        },
	        on: {
	          "change": function($event) {
	            _vm.selected = railColor.colorOptKey
	          }
	        }
	      })])
	    }))])
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "olst-field-radio-label"
	  }, [_c('label', {
	    attrs: {
	      "for": _vm.name
	    },
	    domProps: {
	      "textContent": _vm._s(_vm.label)
	    }
	  })]), _vm._l((_vm.options), function(radio, index) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.showElement(index, radio)),
	        expression: "showElement(index, radio)"
	      }],
	      staticClass: "olst-color"
	    }, [_c('div', {
	      staticClass: "olst-tooltip"
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.isHoverImage(index)),
	        expression: "isHoverImage(index)"
	      }],
	      staticClass: "tooltip-container",
	      attrs: {
	        "transition": "tooltip"
	      }
	    }, [_c('div', {
	      staticClass: "tooltip-header",
	      domProps: {
	        "textContent": _vm._s(_vm.getTooltipHeaderLabel(radio.range))
	      }
	    }), _c('div', {
	      staticClass: "tooltip-image-container"
	    }, [_c('img', {
	      attrs: {
	        "src": radio.imageZoomUrl
	      }
	    })]), _c('div', {
	      staticClass: "tooltip-footer",
	      domProps: {
	        "textContent": _vm._s(radio.label)
	      }
	    })])]), _c('div', {
	      staticClass: "radio-image",
	      on: {
	        "mouseenter": function($event) {
	          _vm.setOverElementKey(index)
	        },
	        "mouseleave": function($event) {
	          _vm.setOverElementKey(null)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "olst-label-component",
	      attrs: {
	        "for": index + _vm.name
	      }
	    }, [_c('div', {
	      staticClass: "image-radio-list-overlay",
	      class: {
	        'out-of-stock': radio.outOfStock, 'selected': (_vm.selected === index)
	      }
	    }), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selected),
	        expression: "selected"
	      }],
	      attrs: {
	        "type": "radio",
	        "id": index + _vm.name,
	        "name": _vm.name
	      },
	      domProps: {
	        "value": index,
	        "checked": _vm._q(_vm.selected, index)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selected = index
	        }
	      }
	    }), _c('img', {
	      attrs: {
	        "src": radio.imageUrl
	      }
	    })])])])
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.selectedImage) ? _c('div', {
	    staticClass: "gallery"
	  }, [_c('div', {
	    staticClass: "image-gallery"
	  }, [_c('image-component', {
	    attrs: {
	      "src": _vm.selectedImage,
	      "mouseEnter": _vm.enterOnImage,
	      "mouseMove": _vm.moveOnImage,
	      "mouseLeave": _vm.leaveOnImage,
	      "onClick": _vm.toggleZoom
	    }
	  }), _c('zoom-area', {
	    attrs: {
	      "isDisplayed": _vm.displayZoom,
	      "image": _vm.selectedImage,
	      "onClick": _vm.toggleZoom,
	      "firstPosition": _vm.positionOnImage
	    }
	  })], 1), _c('div', {
	    staticClass: "image-list-gallery"
	  }, [_c('image-radio-list', {
	    attrs: {
	      "name": "gallery-list",
	      "options": _vm.list,
	      "defaultField": _vm.selectedIndex
	    },
	    on: {
	      "value-changed": _vm.imageChanged
	    }
	  })], 1)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.selectedImage) ? _c('div', {
	    staticClass: "gallery modal-gallery"
	  }, [_c('div', {
	    staticClass: "image-gallery"
	  }, [_c('image-component', {
	    attrs: {
	      "src": _vm.selectedImage,
	      "mouseEnter": _vm.enterOnImage,
	      "mouseLeave": _vm.leaveOnImage
	    }
	  }), _c('gallery-zoom', {
	    attrs: {
	      "isDisplayed": _vm.displayZoom,
	      "image": _vm.selectedImage,
	      "onClick": _vm.toggleModal,
	      "firstPosition": _vm.positionOnImage
	    }
	  })], 1), _c('div', {
	    staticClass: "image-list-gallery"
	  }, [_c('image-radio-list', {
	    attrs: {
	      "name": "gallery-list",
	      "options": _vm.list,
	      "defaultField": _vm.selectedIndex
	    },
	    on: {
	      "value-changed": _vm.imageChanged
	    }
	  })], 1), _c('gallery-modal', {
	    attrs: {
	      "isDisplayed": _vm.modalDisplayed
	    },
	    on: {
	      "close-modal": _vm.closeModal
	    }
	  }, [_c('div', {
	    staticClass: "modal-image-gallery"
	  }, [_c('div', {
	    staticClass: "modal-image-container"
	  }, [_c('image-component', {
	    attrs: {
	      "src": _vm.selectedImage,
	      "onClick": _vm.toggleZoomModal
	    }
	  }), _c('zoom-in-place', {
	    attrs: {
	      "isDisplayed": _vm.displayZoomInModal,
	      "image": _vm.selectedImage,
	      "onClick": _vm.toggleZoomModal
	    }
	  })], 1)]), _c('div', {
	    staticClass: "modal-image-list-gallery"
	  }, [_c('image-radio-list', {
	    attrs: {
	      "name": "modal-gallery-list",
	      "options": _vm.list,
	      "defaultField": _vm.selectedIndex
	    },
	    on: {
	      "value-changed": _vm.imageChanged
	    }
	  })], 1), _c('div', {
	    staticClass: "olst-clear"
	  })])], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'olst-field-error': _vm.hasError, 'olst-field-warning': _vm.hasWarning, 'olst-field-info': _vm.hasInfo
	    }
	  }, [_c('div', {
	    staticClass: "olst-field-material"
	  }, [_c('div', [_c('label-component', {
	    staticClass: "olst-field-label",
	    attrs: {
	      "name": _vm.fieldRef,
	      "text": _vm.field.label
	    }
	  }), (_vm.field.toolTip && _vm.field.toolTip.length) ? _c('modal', {
	    attrs: {
	      "name": _vm.fieldRef,
	      "tooltip": _vm.field.toolTip
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "olst-material-color-label",
	    domProps: {
	      "innerHTML": _vm._s(_vm.imageLabel)
	    }
	  })], 1), (_vm.filters && _vm.filters.length) ? _c('div', {
	    staticClass: "olst-material-checkbox"
	  }, [_vm._l((_vm.filters), function(filter) {
	    return _c('div', {
	      staticClass: "olst-field-checkbox olst-field-multi-checkbox olst-field-checkbox",
	      class: {
	        'olst-field-unique-checkbox': !_vm.hasMultiCheckbox(), 'olst-field-checkbox-big': _vm.isBigCheckboxList(filter.key), 'olst-field-checkbox-small': !_vm.isBigCheckboxList(filter.key)
	      }
	    }, [_c('checkbox-list', {
	      attrs: {
	        "name": filter.key,
	        "filter": filter.value,
	        "withAll": true
	      },
	      on: {
	        "value-changed": _vm.filterChanged
	      }
	    })], 1)
	  }), _c('div', {
	    staticClass: "olst-clear"
	  })], 2) : _vm._e(), _c('div', [_c('div', {
	    staticClass: "olst-color-picker"
	  }, [_c('image-radio-list-with-tooltip', {
	    attrs: {
	      "options": _vm.field.values,
	      "name": _vm.fieldRef,
	      "tooltip_options": _vm.field.range,
	      "hiddenValues": _vm.hiddenValue,
	      "disabledValues": _vm.disabledValue,
	      "defaultField": _vm.field.defaultVal
	    },
	    on: {
	      "image-label-changed": _vm.imageLabelChanged,
	      "value-changed": _vm.fieldChanged
	    }
	  })], 1)])]), _vm._l((_vm.field.validation), function(messages, key, index) {
	    return (_vm.isValidationMessage(key)) ? _c('div', {
	      staticClass: "olst-field-validation"
	    }, _vm._l((messages), function(message) {
	      return _c('div', {
	        class: {
	          'olst-field-error': _vm.isTypeError(key), 'olst-field-warning': _vm.isTypeWarning(key), 'olst-field-infos': _vm.isTypeInfo(key)
	        }
	      }, [_c('text-component', {
	        attrs: {
	          "text": _vm.__t(message)
	        }
	      })], 1)
	    })) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "olst-field-radio-label"
	  }, [_c('label', {
	    attrs: {
	      "for": _vm.name
	    },
	    domProps: {
	      "textContent": _vm._s(_vm.label)
	    }
	  })]), _vm._l((_vm.options), function(radio, index) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.showElement(index, radio)),
	        expression: "showElement(index, radio)"
	      }],
	      staticClass: "olst-color"
	    }, [_c('div', {
	      staticClass: "radio-image",
	      on: {
	        "mouseenter": function($event) {
	          _vm.setOverElementKey(index)
	        }
	      }
	    }, [_c('label', {
	      staticClass: "olst-label-component",
	      attrs: {
	        "for": index + _vm.name
	      }
	    }, [_c('div', {
	      staticClass: "image-radio-list-overlay",
	      class: {
	        'out-of-stock': radio.outOfStock, 'selected': (_vm.selected === index)
	      }
	    }), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selected),
	        expression: "selected"
	      }],
	      attrs: {
	        "type": "radio",
	        "id": index + _vm.name,
	        "name": _vm.name
	      },
	      domProps: {
	        "value": index,
	        "checked": _vm._q(_vm.selected, index)
	      },
	      on: {
	        "change": function($event) {
	          _vm.selected = index
	        }
	      }
	    }), _c('img', {
	      attrs: {
	        "src": radio.imageUrl
	      }
	    })])])])
	  })], 2)
	},staticRenderFns: []}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.js